/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement Annonces Legale Api
 * API de gestion des annonces légales
 *
 * The version of the OpenAPI document: 1.16.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AnnonceLGaleTraitementDeStatuts
 */
export interface AnnonceLGaleTraitementDeStatuts {
    /**
     * Fichiers de statuts à traiter (PDF, DOCX, DOC, ODT...)
     * @type {Array<File>}
     * @memberof AnnonceLGaleTraitementDeStatuts
     */
    'documents': Array<File>;
    /**
     * Référence client - obligatoire
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatuts
     */
    'refClient': string | null;
    /**
     * Identifiant du sous-type d\'annonce légale (IDSType) - optionnel
     * @type {number}
     * @memberof AnnonceLGaleTraitementDeStatuts
     */
    'typeAnnonce'?: number | null;
    /**
     * Code du département - optionnel
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatuts
     */
    'departement'?: string | null;
    /**
     * URL de callback appelée après traitement - optionnel
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatuts
     */
    'callbackUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface AnnonceLGaleTraitementDeStatutsJsonld
 */
export interface AnnonceLGaleTraitementDeStatutsJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    '@type'?: string;
    /**
     * Fichiers de statuts à traiter (PDF, DOCX, DOC, ODT...)
     * @type {Array<File>}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    'documents': Array<File>;
    /**
     * Référence client - obligatoire
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    'refClient': string | null;
    /**
     * Identifiant du sous-type d\'annonce légale (IDSType) - optionnel
     * @type {number}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    'typeAnnonce'?: number | null;
    /**
     * Code du département - optionnel
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    'departement'?: string | null;
    /**
     * URL de callback appelée après traitement - optionnel
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonld
     */
    'callbackUrl'?: string | null;
}
/**
 * @type AnnonceLGaleTraitementDeStatutsJsonldContext
 * @export
 */
export type AnnonceLGaleTraitementDeStatutsJsonldContext = AnnonceLGaleTraitementDeStatutsJsonldContextOneOf | string;

/**
 * 
 * @export
 * @interface AnnonceLGaleTraitementDeStatutsJsonldContextOneOf
 */
export interface AnnonceLGaleTraitementDeStatutsJsonldContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonldContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLGaleTraitementDeStatutsJsonldContextOneOf
     */
    'hydra': AnnonceLGaleTraitementDeStatutsJsonldContextOneOfHydraEnum;
}

export const AnnonceLGaleTraitementDeStatutsJsonldContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type AnnonceLGaleTraitementDeStatutsJsonldContextOneOfHydraEnum = typeof AnnonceLGaleTraitementDeStatutsJsonldContextOneOfHydraEnum[keyof typeof AnnonceLGaleTraitementDeStatutsJsonldContextOneOfHydraEnum];

/**
 * 
 * @export
 * @interface AnnonceLegale
 */
export interface AnnonceLegale {
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegale
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegale
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {TblCategorie}
     * @memberof AnnonceLegale
     */
    'categorie'?: TblCategorie | null;
    /**
     * 
     * @type {TblAnnonceType}
     * @memberof AnnonceLegale
     */
    'type'?: TblAnnonceType | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'bodacc'?: boolean | null;
    /**
     * 
     * @type {TblFormulaire}
     * @memberof AnnonceLegale
     */
    'formulaire'?: TblFormulaire | null;
    /**
     * 
     * @type {Array<TblAnnonceSTypeSeo>}
     * @memberof AnnonceLegale
     */
    'informationsSeo'?: Array<TblAnnonceSTypeSeo>;
    /**
     * 
     * @type {Array<TblCategorieForfait>}
     * @memberof AnnonceLegale
     */
    'categoriesForfait'?: Array<TblCategorieForfait>;
    /**
     * 
     * @type {Array<TblRelationSTypeDetail>}
     * @memberof AnnonceLegale
     */
    'formesJuridiques'?: Array<TblRelationSTypeDetail>;
    /**
     * 
     * @type {Array<TblRelationStypeOrigine>}
     * @memberof AnnonceLegale
     */
    'origines'?: Array<TblRelationStypeOrigine>;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegale
     */
    'actif'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegale
     */
    'spelAccepte'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'tarifForfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegale
     */
    'typeLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'defautWebMdfG3'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegale
     */
    'typeLibelleWeb'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'actifRechercheWeb'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'paiementImpose'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'devisBloque'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'libreonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'b2babre'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegale
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'doubleAnnonce'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'cpjalBloque'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegale
     */
    'defautMB'?: boolean;
    /**
     * Retreive the minimum application date among TblCategorieForfait relationships of a sType
     * @type {string}
     * @memberof AnnonceLegale
     */
    'minimumStartDate'?: string | null;
}
/**
 * 
 * @export
 * @interface AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
 */
export interface AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'typeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'typeLibelleWeb'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'libreonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'b2babre'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'actif'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'spelAccepte'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'bodacc'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'auForfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'tarifHt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'tarifMajore'?: string;
    /**
     * 
     * @type {CategorieAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'categorie'?: CategorieAnnonceLegaleReadCollection;
    /**
     * 
     * @type {FormulaireAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'formulaire'?: FormulaireAnnonceLegaleReadCollection;
    /**
     * 
     * @type {TypeAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'type'?: TypeAnnonceLegaleReadCollection;
    /**
     * 
     * @type {InformationSeoAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'informationSeo'?: InformationSeoAnnonceLegaleReadCollection;
    /**
     * 
     * @type {Array<FormeJuridiqueAnnonceLegaleReadCollection>}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadCollection
     */
    'formesJuridiques'?: Array<FormeJuridiqueAnnonceLegaleReadCollection>;
}
/**
 * 
 * @export
 * @interface AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
 */
export interface AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem {
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'typeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'typeLibelleWeb'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'libreonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'b2babre'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'actif'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'spelAccepte'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'bodacc'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'auForfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'tarifHt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'tarifMajore'?: string;
    /**
     * 
     * @type {CategorieAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'categorie'?: CategorieAnnonceLegaleReadItem;
    /**
     * 
     * @type {FormulaireAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'formulaire'?: FormulaireAnnonceLegaleReadItem;
    /**
     * 
     * @type {TypeAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'type'?: TypeAnnonceLegaleReadItem;
    /**
     * 
     * @type {InformationSeoAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'informationSeo'?: InformationSeoAnnonceLegaleReadItem;
    /**
     * 
     * @type {Array<FormeJuridiqueAnnonceLegaleReadItem>}
     * @memberof AnnonceLegaleAnnonceLegaleAnnonceLegaleReadItem
     */
    'formesJuridiques'?: Array<FormeJuridiqueAnnonceLegaleReadItem>;
}
/**
 * 
 * @export
 * @interface AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
 */
export interface AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection {
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'typeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'typeLibelleWeb'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'libreonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'b2babre'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'actif'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'spelAccepte'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'bodacc'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'auForfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'tarifHt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'tarifMajore'?: string;
    /**
     * 
     * @type {CategorieJsonldAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'categorie'?: CategorieJsonldAnnonceLegaleReadCollection;
    /**
     * 
     * @type {FormulaireJsonldAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'formulaire'?: FormulaireJsonldAnnonceLegaleReadCollection;
    /**
     * 
     * @type {TypeJsonldAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'type'?: TypeJsonldAnnonceLegaleReadCollection;
    /**
     * 
     * @type {InformationSeoJsonldAnnonceLegaleReadCollection}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'informationSeo'?: InformationSeoJsonldAnnonceLegaleReadCollection;
    /**
     * 
     * @type {Array<FormeJuridiqueJsonldAnnonceLegaleReadCollection>}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection
     */
    'formesJuridiques'?: Array<FormeJuridiqueJsonldAnnonceLegaleReadCollection>;
}
/**
 * 
 * @export
 * @interface AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
 */
export interface AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'typeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'typeLibelleWeb'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'libreonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'b2babre'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'actif'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'spelAccepte'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'bodacc'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'auForfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'tarifHt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'tarifMajore'?: string;
    /**
     * 
     * @type {CategorieJsonldAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'categorie'?: CategorieJsonldAnnonceLegaleReadItem;
    /**
     * 
     * @type {FormulaireJsonldAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'formulaire'?: FormulaireJsonldAnnonceLegaleReadItem;
    /**
     * 
     * @type {TypeJsonldAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'type'?: TypeJsonldAnnonceLegaleReadItem;
    /**
     * 
     * @type {InformationSeoJsonldAnnonceLegaleReadItem}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'informationSeo'?: InformationSeoJsonldAnnonceLegaleReadItem;
    /**
     * 
     * @type {Array<FormeJuridiqueJsonldAnnonceLegaleReadItem>}
     * @memberof AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem
     */
    'formesJuridiques'?: Array<FormeJuridiqueJsonldAnnonceLegaleReadItem>;
}
/**
 * 
 * @export
 * @interface AnnonceLegaleJsonld
 */
export interface AnnonceLegaleJsonld {
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof AnnonceLegaleJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {TblCategorieJsonld}
     * @memberof AnnonceLegaleJsonld
     */
    'categorie'?: TblCategorieJsonld | null;
    /**
     * 
     * @type {TblAnnonceTypeJsonld}
     * @memberof AnnonceLegaleJsonld
     */
    'type'?: TblAnnonceTypeJsonld | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'bodacc'?: boolean | null;
    /**
     * 
     * @type {TblFormulaireJsonld}
     * @memberof AnnonceLegaleJsonld
     */
    'formulaire'?: TblFormulaireJsonld | null;
    /**
     * 
     * @type {Array<TblAnnonceSTypeSeoJsonld>}
     * @memberof AnnonceLegaleJsonld
     */
    'informationsSeo'?: Array<TblAnnonceSTypeSeoJsonld>;
    /**
     * 
     * @type {Array<TblCategorieForfaitJsonld>}
     * @memberof AnnonceLegaleJsonld
     */
    'categoriesForfait'?: Array<TblCategorieForfaitJsonld>;
    /**
     * 
     * @type {Array<TblRelationSTypeDetailJsonld>}
     * @memberof AnnonceLegaleJsonld
     */
    'formesJuridiques'?: Array<TblRelationSTypeDetailJsonld>;
    /**
     * 
     * @type {Array<TblRelationStypeOrigineJsonld>}
     * @memberof AnnonceLegaleJsonld
     */
    'origines'?: Array<TblRelationStypeOrigineJsonld>;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleJsonld
     */
    'actif'?: number;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleJsonld
     */
    'spelAccepte'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'tarifForfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonld
     */
    'typeLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'defautWebMdfG3'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonld
     */
    'typeLibelleWeb'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'actifRechercheWeb'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'paiementImpose'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'devisBloque'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'libreonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'b2babre'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegaleJsonld
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'doubleAnnonce'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'cpjalBloque'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegaleJsonld
     */
    'defautMB'?: boolean;
    /**
     * Retreive the minimum application date among TblCategorieForfait relationships of a sType
     * @type {string}
     * @memberof AnnonceLegaleJsonld
     */
    'minimumStartDate'?: string | null;
}
/**
 * 
 * @export
 * @interface AnnonceLegaleJsonldAnnonceLegaleReadPricing
 */
export interface AnnonceLegaleJsonldAnnonceLegaleReadPricing {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof AnnonceLegaleJsonldAnnonceLegaleReadPricing
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonldAnnonceLegaleReadPricing
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegaleJsonldAnnonceLegaleReadPricing
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface AnnonceLegalePricingDtoAnnonceLegaleReadPricing
 */
export interface AnnonceLegalePricingDtoAnnonceLegaleReadPricing {
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegalePricingDtoAnnonceLegaleReadPricing
     */
    'sTypeId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegalePricingDtoAnnonceLegaleReadPricing
     */
    'stypeAuForfait'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegalePricingDtoAnnonceLegaleReadPricing
     */
    'montantForfait'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegalePricingDtoAnnonceLegaleReadPricing
     */
    'stypeAuCaractereHT'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
 */
export interface AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing {
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
     */
    'sTypeId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
     */
    'stypeAuForfait'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
     */
    'montantForfait'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing
     */
    'stypeAuCaractereHT'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CategorieAnnonceLegaleReadCollection
 */
export interface CategorieAnnonceLegaleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof CategorieAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieAnnonceLegaleReadCollection
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface CategorieAnnonceLegaleReadItem
 */
export interface CategorieAnnonceLegaleReadItem {
    /**
     * 
     * @type {number}
     * @memberof CategorieAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieAnnonceLegaleReadItem
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface CategorieJsonldAnnonceLegaleReadCollection
 */
export interface CategorieJsonldAnnonceLegaleReadCollection {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof CategorieJsonldAnnonceLegaleReadCollection
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldAnnonceLegaleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldAnnonceLegaleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategorieJsonldAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldAnnonceLegaleReadCollection
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface CategorieJsonldAnnonceLegaleReadItem
 */
export interface CategorieJsonldAnnonceLegaleReadItem {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof CategorieJsonldAnnonceLegaleReadItem
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldAnnonceLegaleReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldAnnonceLegaleReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategorieJsonldAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategorieJsonldAnnonceLegaleReadItem
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface FormeJuridiqueAnnonceLegaleReadCollection
 */
export interface FormeJuridiqueAnnonceLegaleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'abreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'dirigeant'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'dirigeance'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'objetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'capvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'agrement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadCollection
     */
    'sci'?: boolean;
}
/**
 * 
 * @export
 * @interface FormeJuridiqueAnnonceLegaleReadItem
 */
export interface FormeJuridiqueAnnonceLegaleReadItem {
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'abreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'dirigeant'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'dirigeance'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'objetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'capvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'agrement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueAnnonceLegaleReadItem
     */
    'sci'?: boolean;
}
/**
 * 
 * @export
 * @interface FormeJuridiqueJsonldAnnonceLegaleReadCollection
 */
export interface FormeJuridiqueJsonldAnnonceLegaleReadCollection {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'abreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'dirigeant'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'dirigeance'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'objetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'capvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'agrement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadCollection
     */
    'sci'?: boolean;
}
/**
 * 
 * @export
 * @interface FormeJuridiqueJsonldAnnonceLegaleReadItem
 */
export interface FormeJuridiqueJsonldAnnonceLegaleReadItem {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'abreviation'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'dirigeant'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'dirigeance'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'objetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'capvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'agrement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormeJuridiqueJsonldAnnonceLegaleReadItem
     */
    'sci'?: boolean;
}
/**
 * 
 * @export
 * @interface FormulaireAnnonceLegaleReadCollection
 */
export interface FormulaireAnnonceLegaleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof FormulaireAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormulaireAnnonceLegaleReadCollection
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface FormulaireAnnonceLegaleReadItem
 */
export interface FormulaireAnnonceLegaleReadItem {
    /**
     * 
     * @type {number}
     * @memberof FormulaireAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormulaireAnnonceLegaleReadItem
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface FormulaireJsonldAnnonceLegaleReadCollection
 */
export interface FormulaireJsonldAnnonceLegaleReadCollection {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FormulaireJsonldAnnonceLegaleReadCollection
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FormulaireJsonldAnnonceLegaleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormulaireJsonldAnnonceLegaleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormulaireJsonldAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormulaireJsonldAnnonceLegaleReadCollection
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface FormulaireJsonldAnnonceLegaleReadItem
 */
export interface FormulaireJsonldAnnonceLegaleReadItem {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FormulaireJsonldAnnonceLegaleReadItem
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FormulaireJsonldAnnonceLegaleReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormulaireJsonldAnnonceLegaleReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormulaireJsonldAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FormulaireJsonldAnnonceLegaleReadItem
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface FproDossier
 */
export interface FproDossier {
    /**
     * 
     * @type {number}
     * @memberof FproDossier
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossier
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierJsonld
 */
export interface FproDossierJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FproDossierJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonld
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierValidator
 */
export interface FproDossierValidator {
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidator
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidator
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorJsonld
 */
export interface FproDossierValidatorJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FproDossierValidatorJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorJsonld
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorProcess
 */
export interface FproDossierValidatorProcess {
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorProcess
     */
    'id'?: number;
    /**
     * 
     * @type {FproDossier}
     * @memberof FproDossierValidatorProcess
     */
    'dossier'?: FproDossier;
    /**
     * 
     * @type {FproDossierValidator}
     * @memberof FproDossierValidatorProcess
     */
    'validator'?: FproDossierValidator;
    /**
     * 
     * @type {FproDossierValidatorTypeStatus}
     * @memberof FproDossierValidatorProcess
     */
    'status'?: FproDossierValidatorTypeStatus;
    /**
     * 
     * @type {FproDossierValidatorProcessDetail}
     * @memberof FproDossierValidatorProcess
     */
    'details'?: FproDossierValidatorProcessDetail | null;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorProcessDetail
 */
export interface FproDossierValidatorProcessDetail {
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorProcessDetail
     */
    'id'?: number;
    /**
     * 
     * @type {FproDossierValidatorProcess}
     * @memberof FproDossierValidatorProcessDetail
     */
    'validationProcess'?: FproDossierValidatorProcess;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorProcessDetail
     */
    'presta'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorProcessDetailJsonld
 */
export interface FproDossierValidatorProcessDetailJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FproDossierValidatorProcessDetailJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorProcessDetailJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorProcessDetailJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorProcessDetailJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {FproDossierValidatorProcessJsonld}
     * @memberof FproDossierValidatorProcessDetailJsonld
     */
    'validationProcess'?: FproDossierValidatorProcessJsonld;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorProcessDetailJsonld
     */
    'presta'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorProcessJsonld
 */
export interface FproDossierValidatorProcessJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FproDossierValidatorProcessJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorProcessJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorProcessJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorProcessJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {FproDossierJsonld}
     * @memberof FproDossierValidatorProcessJsonld
     */
    'dossier'?: FproDossierJsonld;
    /**
     * 
     * @type {FproDossierValidatorJsonld}
     * @memberof FproDossierValidatorProcessJsonld
     */
    'validator'?: FproDossierValidatorJsonld;
    /**
     * 
     * @type {FproDossierValidatorTypeStatusJsonld}
     * @memberof FproDossierValidatorProcessJsonld
     */
    'status'?: FproDossierValidatorTypeStatusJsonld;
    /**
     * 
     * @type {FproDossierValidatorProcessDetailJsonld}
     * @memberof FproDossierValidatorProcessJsonld
     */
    'details'?: FproDossierValidatorProcessDetailJsonld | null;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorTypeStatus
 */
export interface FproDossierValidatorTypeStatus {
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorTypeStatus
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorTypeStatus
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierValidatorTypeStatusJsonld
 */
export interface FproDossierValidatorTypeStatusJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof FproDossierValidatorTypeStatusJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorTypeStatusJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorTypeStatusJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof FproDossierValidatorTypeStatusJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FproDossierValidatorTypeStatusJsonld
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection200Response
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection200Response {
    /**
     * 
     * @type {Array<AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection>}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200Response
     */
    'hydra:member': Array<AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadCollection>;
    /**
     * 
     * @type {number}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200Response
     */
    'hydra:view'?: GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200Response
     */
    'hydra:search'?: GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch
     */
    'hydra:template'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch
     */
    'hydra:variableRepresentation'?: string;
    /**
     * 
     * @type {Array<GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner>}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch
     */
    'hydra:mapping'?: Array<GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner>;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner
     */
    'variable'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner
     */
    'property'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearchHydraMappingInner
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
     */
    'hydra:first'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
     */
    'hydra:last'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
     */
    'hydra:previous'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView
     */
    'hydra:next'?: string;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection400Response
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection400Response {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection400Response
     */
    'error'?: string;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection400ResponseException}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection400Response
     */
    'exception'?: GetListAnnoncesLegalesAnnonceLegaleCollection400ResponseException;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection400ResponseException
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection400ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection401Response
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection401Response {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection403Response
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection403Response {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection403Response
     */
    'error'?: string;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection403ResponseException}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection403Response
     */
    'exception'?: GetListAnnoncesLegalesAnnonceLegaleCollection403ResponseException;
}
/**
 * 
 * @export
 * @interface GetListAnnoncesLegalesAnnonceLegaleCollection403ResponseException
 */
export interface GetListAnnoncesLegalesAnnonceLegaleCollection403ResponseException {
    /**
     * 
     * @type {string}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection403ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetListAnnoncesLegalesAnnonceLegaleCollection403ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface GetListTblPrestaPrestationAnnonceLGaleCollection200Response
 */
export interface GetListTblPrestaPrestationAnnonceLGaleCollection200Response {
    /**
     * 
     * @type {Array<PrestationAnnonceLGaleJsonldPrestaRead>}
     * @memberof GetListTblPrestaPrestationAnnonceLGaleCollection200Response
     */
    'hydra:member': Array<PrestationAnnonceLGaleJsonldPrestaRead>;
    /**
     * 
     * @type {number}
     * @memberof GetListTblPrestaPrestationAnnonceLGaleCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView}
     * @memberof GetListTblPrestaPrestationAnnonceLGaleCollection200Response
     */
    'hydra:view'?: GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch}
     * @memberof GetListTblPrestaPrestationAnnonceLGaleCollection200Response
     */
    'hydra:search'?: GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner
 */
export interface GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner
     */
    'idPresta'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner
     */
    'RefCdeClient'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner
     */
    'Annonceur'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner
     */
    'DEP'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner
     */
    'IDSType'?: number;
}
/**
 * 
 * @export
 * @interface GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner
 */
export interface GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner
     */
    'idstype': string;
    /**
     * 
     * @type {string}
     * @memberof GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner
     */
    'libelle': string;
    /**
     * 
     * @type {string}
     * @memberof GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner
     */
    'shorturl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner
     */
    'presta_count': string;
}
/**
 * 
 * @export
 * @interface GetParutionsJalEditionAnnonceLegaleCollection200Response
 */
export interface GetParutionsJalEditionAnnonceLegaleCollection200Response {
    /**
     * Nom du support de diffusion
     * @type {string}
     * @memberof GetParutionsJalEditionAnnonceLegaleCollection200Response
     */
    'support'?: string;
    /**
     * 
     * @type {Array<GetParutionsJalEditionAnnonceLegaleCollection200ResponseDatesInner>}
     * @memberof GetParutionsJalEditionAnnonceLegaleCollection200Response
     */
    'dates'?: Array<GetParutionsJalEditionAnnonceLegaleCollection200ResponseDatesInner>;
}
/**
 * 
 * @export
 * @interface GetParutionsJalEditionAnnonceLegaleCollection200ResponseDatesInner
 */
export interface GetParutionsJalEditionAnnonceLegaleCollection200ResponseDatesInner {
    /**
     * Date de parution
     * @type {string}
     * @memberof GetParutionsJalEditionAnnonceLegaleCollection200ResponseDatesInner
     */
    'dateParution'?: string;
    /**
     * Date et heure de bouclage (Bouclage + HBouclage)
     * @type {string}
     * @memberof GetParutionsJalEditionAnnonceLegaleCollection200ResponseDatesInner
     */
    'dateHeureBouclage'?: string;
}
/**
 * 
 * @export
 * @interface GetPricingAnnonceLegaleItem200Response
 */
export interface GetPricingAnnonceLegaleItem200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetPricingAnnonceLegaleItem200Response
     */
    'stype_au_forfait'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPricingAnnonceLegaleItem200Response
     */
    'montant_forfait'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetPricingAnnonceLegaleItem200Response
     */
    'stype_au_caractere_HT'?: boolean;
}
/**
 * 
 * @export
 * @interface GetPricingsAnnonceLegaleCollection200Response
 */
export interface GetPricingsAnnonceLegaleCollection200Response {
    /**
     * 
     * @type {Array<AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing>}
     * @memberof GetPricingsAnnonceLegaleCollection200Response
     */
    'hydra:member': Array<AnnonceLegalePricingDtoJsonldAnnonceLegaleReadPricing>;
    /**
     * 
     * @type {number}
     * @memberof GetPricingsAnnonceLegaleCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView}
     * @memberof GetPricingsAnnonceLegaleCollection200Response
     */
    'hydra:view'?: GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraView;
    /**
     * 
     * @type {GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch}
     * @memberof GetPricingsAnnonceLegaleCollection200Response
     */
    'hydra:search'?: GetListAnnoncesLegalesAnnonceLegaleCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetSupportAnnonceLegaleCollection200ResponseInner
 */
export interface GetSupportAnnonceLegaleCollection200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'idJalEdition'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'dep'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'attestation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'justif'?: GetSupportAnnonceLegaleCollection200ResponseInnerJustifEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'diffusion'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'typePresse'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'libelleTypePresse'?: string;
    /**
     * 0=aucun, 1=SPEL, 2=groupe2, 3=groupe, 4=pref direct, 5=pref XL
     * @type {number}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'jalPref'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'logoAutorise'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'coupureDiffusion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSupportAnnonceLegaleCollection200ResponseInner
     */
    'nbJoursCoupureDiffusion'?: number;
}

export const GetSupportAnnonceLegaleCollection200ResponseInnerJustifEnum = {
    Ok: 'OK',
    Ko: 'KO'
} as const;

export type GetSupportAnnonceLegaleCollection200ResponseInnerJustifEnum = typeof GetSupportAnnonceLegaleCollection200ResponseInnerJustifEnum[keyof typeof GetSupportAnnonceLegaleCollection200ResponseInnerJustifEnum];

/**
 * 
 * @export
 * @interface GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner
 */
export interface GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner
     */
    'idLiv'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner
     */
    'idTiers'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner
     */
    'adresse'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner
     */
    'nbExemp'?: number;
}
/**
 * 
 * @export
 * @interface GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response
 */
export interface GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response {
    /**
     * PDF encodé en base 64
     * @type {string}
     * @memberof GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response
     */
    'pdfBase64'?: string;
    /**
     * Information sur le retour
     * @type {string}
     * @memberof GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response
     */
    'sEtat'?: string;
    /**
     * Code état (1 = succès)
     * @type {number}
     * @memberof GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response
     */
    'nEtatCode'?: number;
    /**
     * Lien public du justificatif
     * @type {string}
     * @memberof GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response
     */
    'lienPublic'?: string;
}
/**
 * 
 * @export
 * @interface GetTblPrestaJustifJalPrestationAnnonceLGaleItem422Response
 */
export interface GetTblPrestaJustifJalPrestationAnnonceLGaleItem422Response {
    /**
     * 
     * @type {string}
     * @memberof GetTblPrestaJustifJalPrestationAnnonceLGaleItem422Response
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTblPrestaJustifJalPrestationAnnonceLGaleItem422Response
     */
    'nEtatCode'?: number;
}
/**
 * 
 * @export
 * @interface GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
 */
export interface GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'IDSType'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'IDOrigine'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'flg_main'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'IDTypeAnnonce'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'TypeAnnonce'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'type_libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'shorturl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'TypeSociete'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'libellepardef'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'abreviationtypedetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'listestypedetail'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'libreonly'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'idformulaire'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'b2babre'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'rang'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'f_actif'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'metadescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'f_spelaccepte'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner
     */
    'F_Tarif_Forfait'?: number;
}
/**
 * 
 * @export
 * @interface InformationSeoAnnonceLegaleReadCollection
 */
export interface InformationSeoAnnonceLegaleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof InformationSeoAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadCollection
     */
    'titre'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadCollection
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadCollection
     */
    'shortUrl'?: string;
}
/**
 * 
 * @export
 * @interface InformationSeoAnnonceLegaleReadItem
 */
export interface InformationSeoAnnonceLegaleReadItem {
    /**
     * 
     * @type {number}
     * @memberof InformationSeoAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadItem
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadItem
     */
    'titre'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoAnnonceLegaleReadItem
     */
    'shortUrl'?: string;
}
/**
 * 
 * @export
 * @interface InformationSeoJsonldAnnonceLegaleReadCollection
 */
export interface InformationSeoJsonldAnnonceLegaleReadCollection {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    'titre'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadCollection
     */
    'shortUrl'?: string;
}
/**
 * 
 * @export
 * @interface InformationSeoJsonldAnnonceLegaleReadItem
 */
export interface InformationSeoJsonldAnnonceLegaleReadItem {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    'titre'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InformationSeoJsonldAnnonceLegaleReadItem
     */
    'shortUrl'?: string;
}
/**
 * 
 * @export
 * @interface PalmaresSTypesAnnoncesLegales
 */
export interface PalmaresSTypesAnnoncesLegales {
    /**
     * 
     * @type {number}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'nTopResults': number;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'idstype'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'shorturl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'presta_count'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'iDSType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegales
     */
    'prestaCount'?: string | null;
}
/**
 * 
 * @export
 * @interface PalmaresSTypesAnnoncesLegalesJsonld
 */
export interface PalmaresSTypesAnnoncesLegalesJsonld {
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'nTopResults': number;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'idstype'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'shorturl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'presta_count'?: string;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'iDSType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PalmaresSTypesAnnoncesLegalesJsonld
     */
    'prestaCount'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchAnnuleAnnonceLegaleAnnonceLegaleItem200Response
 */
export interface PatchAnnuleAnnonceLegaleAnnonceLegaleItem200Response {
    /**
     * 
     * @type {number}
     * @memberof PatchAnnuleAnnonceLegaleAnnonceLegaleItem200Response
     */
    'idPresta'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof PatchAnnuleAnnonceLegaleAnnonceLegaleItem200Response
     */
    'factures'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PatchAnnuleAnnonceLegaleAnnonceLegaleItem422Response
 */
export interface PatchAnnuleAnnonceLegaleAnnonceLegaleItem422Response {
    /**
     * 
     * @type {string}
     * @memberof PatchAnnuleAnnonceLegaleAnnonceLegaleItem422Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest
 */
export interface PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest
     */
    'fCoupureDiffusion'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
 */
export interface PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
     */
    'idTiers'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
     */
    'nbExemp'?: number;
}
/**
 * 
 * @export
 * @interface PostAnnonceLegaleAnnonceLegaleCollection201Response
 */
export interface PostAnnonceLegaleAnnonceLegaleCollection201Response {
    /**
     * 
     * @type {number}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'idPresta'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'montantHT'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'montantTVA'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'montantTTC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'nomJal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'dateParution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'dateHeureBouclage'?: string | null;
    /**
     * URL de téléchargement de l\'attestation (presigned S3)
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'attestationUrl'?: string | null;
    /**
     * 
     * @type {Array<PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner>}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'factures'?: Array<PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'coupureDiffusion'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'jalCoupureDiffusion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'nbJoursCoupureDiffusion'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'numeroAnnonce'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201Response
     */
    'numeroDossier'?: string | null;
}
/**
 * 
 * @export
 * @interface PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner
 */
export interface PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner {
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner
     */
    'sNumFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner
     */
    'sDFacture'?: string | null;
    /**
     * URL de téléchargement de la facture (presigned S3)
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection201ResponseFacturesInner
     */
    'factureUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface PostAnnonceLegaleAnnonceLegaleCollection404Response
 */
export interface PostAnnonceLegaleAnnonceLegaleCollection404Response {
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection404Response
     */
    'error'?: string;
    /**
     * 
     * @type {PostAnnonceLegaleAnnonceLegaleCollection404ResponseException}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection404Response
     */
    'exception'?: PostAnnonceLegaleAnnonceLegaleCollection404ResponseException;
}
/**
 * 
 * @export
 * @interface PostAnnonceLegaleAnnonceLegaleCollection404ResponseException
 */
export interface PostAnnonceLegaleAnnonceLegaleCollection404ResponseException {
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection404ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollection404ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface PostAnnonceLegaleAnnonceLegaleCollectionRequest
 */
export interface PostAnnonceLegaleAnnonceLegaleCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'RefCdeClient': string;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'Annonceur': string;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'annonce1': string;
    /**
     * 
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'DEP': string;
    /**
     * 
     * @type {number}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'IDSType': number;
    /**
     * Date de parution souhaitée (YYYY-MM-DD). Si absente, le JAL choisit la prochaine date disponible.
     * @type {string}
     * @memberof PostAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'dateParution'?: string | null;
}
/**
 * 
 * @export
 * @interface PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
 */
export interface PostPrixAnnonceLegaleAnnonceLegaleCollection200Response {
    /**
     * Montant hors taxes
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'montantHT'?: string;
    /**
     * Montant de la TVA
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'montantTVA'?: string;
    /**
     * Montant toutes taxes comprises
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'montantTTC'?: string;
    /**
     * Nom du support de diffusion
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'nomJal'?: string;
    /**
     * Date de parution prévue
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'dateParution'?: string;
    /**
     * Date et heure de bouclage
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'dateHeureBouclage'?: string;
    /**
     * Coupure de diffusion possible pour ce support
     * @type {boolean}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'jalCoupureDiffusion'?: boolean;
    /**
     * Nombre de jours avant la coupure de diffusion
     * @type {number}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollection200Response
     */
    'nbJoursCoupureDiffusion'?: number;
}
/**
 * 
 * @export
 * @interface PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest
 */
export interface PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest {
    /**
     * Texte de l\'annonce
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'annonce1': string;
    /**
     * Code département (2 ou 3 caractères)
     * @type {string}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'DEP': string;
    /**
     * Identifiant du sous-type d\'annonce
     * @type {number}
     * @memberof PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest
     */
    'IDSType': number;
}
/**
 * 
 * @export
 * @interface PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
 */
export interface PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response {
    /**
     * 
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
     */
    'idLiv'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
     */
    'idPrescripteur'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
     */
    'idTiers'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
     */
    'idPresta'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
     */
    'adresse'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response
     */
    'nbExemp'?: number;
}
/**
 * 
 * @export
 * @interface PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
 */
export interface PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest {
    /**
     * ID du tiers destinataire (prescripteur ou sous-client)
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
     */
    'idTiers': number;
    /**
     * Nombre d\'exemplaires souhaités
     * @type {number}
     * @memberof PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
     */
    'nbExemp': number;
}
/**
 * 
 * @export
 * @interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection202Response
 */
export interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection202Response {
    /**
     * 
     * @type {string}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection202Response
     */
    'message'?: string;
    /**
     * Code HTTP retourné par le webhook n8n
     * @type {number}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection202Response
     */
    'webhookStatus'?: number;
}
/**
 * 
 * @export
 * @interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400Response
 */
export interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400Response {
    /**
     * 
     * @type {string}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400Response
     */
    'error'?: string;
    /**
     * 
     * @type {PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400ResponseException}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400Response
     */
    'exception'?: PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400ResponseException;
}
/**
 * 
 * @export
 * @interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400ResponseException
 */
export interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection400ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502Response
 */
export interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502Response {
    /**
     * 
     * @type {string}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502Response
     */
    'error'?: string;
    /**
     * 
     * @type {PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502ResponseException}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502Response
     */
    'exception'?: PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502ResponseException;
}
/**
 * 
 * @export
 * @interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502ResponseException
 */
export interface PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502ResponseException {
    /**
     * 
     * @type {string}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostTraitementStatutsAnnonceLGaleTraitementDeStatutsCollection502ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGale
 */
export interface PrestationAnnonceLGale {
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGale
     */
    'id'?: number;
    /**
     * 
     * @type {TblDossier2}
     * @memberof PrestationAnnonceLGale
     */
    'dossier'?: TblDossier2 | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'titre'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'typePresta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'dateDemande'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'bouclage'?: string | null;
    /**
     * 
     * @type {TblJal}
     * @memberof PrestationAnnonceLGale
     */
    'jal'?: TblJal | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'justifLienPublic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'annonceur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'lien'?: string | null;
    /**
     * 
     * @type {Array<FproDossierValidatorProcessDetail>}
     * @memberof PrestationAnnonceLGale
     */
    'processDetails'?: Array<FproDossierValidatorProcessDetail>;
    /**
     * 
     * @type {TblBodacc}
     * @memberof PrestationAnnonceLGale
     */
    'bodacc'?: TblBodacc | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'idDocumentAttestation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGale
     */
    'exemplaireNb'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'annonce1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGale
     */
    'entete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGale
     */
    'floId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGale
     */
    'coupureDiffusion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGale
     */
    'idSTypePresta'?: number | null;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGaleAnnonceLegaleReadJustif
 */
export interface PrestationAnnonceLGaleAnnonceLegaleReadJustif {
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleAnnonceLegaleReadJustif
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleAnnonceLegaleReadJustif
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleAnnonceLegaleReadJustif
     */
    'justifLienPublic'?: string | null;
    /**
     * 
     * @type {TblBodaccAnnonceLegaleReadJustif}
     * @memberof PrestationAnnonceLGaleAnnonceLegaleReadJustif
     */
    'bodacc'?: TblBodaccAnnonceLegaleReadJustif | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleAnnonceLegaleReadJustif
     */
    'idDocumentAttestation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGaleAnnonceLegaleReadJustif
     */
    'coupureDiffusion'?: boolean;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGaleJsonld
 */
export interface PrestationAnnonceLGaleJsonld {
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {TblDossier2Jsonld}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'dossier'?: TblDossier2Jsonld | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'titre'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'typePresta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'dateDemande'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'bouclage'?: string | null;
    /**
     * 
     * @type {TblJalJsonld}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'jal'?: TblJalJsonld | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'justifLienPublic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'annonceur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'lien'?: string | null;
    /**
     * 
     * @type {Array<FproDossierValidatorProcessDetailJsonld>}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'processDetails'?: Array<FproDossierValidatorProcessDetailJsonld>;
    /**
     * 
     * @type {TblBodaccJsonld}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'bodacc'?: TblBodaccJsonld | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'idDocumentAttestation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'exemplaireNb'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'annonce1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'entete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'floId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'coupureDiffusion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonld
     */
    'idSTypePresta'?: number | null;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
 */
export interface PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    'justifLienPublic'?: string | null;
    /**
     * 
     * @type {TblBodaccJsonldAnnonceLegaleReadJustif}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    'bodacc'?: TblBodaccJsonldAnnonceLegaleReadJustif | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    'idDocumentAttestation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif
     */
    'coupureDiffusion'?: boolean;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion
 */
export interface PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion
     */
    '@type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion
     */
    'coupureDiffusion'?: boolean;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGaleJsonldPrestaRead
 */
export interface PrestationAnnonceLGaleJsonldPrestaRead {
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblDossier2JsonldPrestaRead}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'dossier'?: TblDossier2JsonldPrestaRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'typePresta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'dateDemande'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'bouclage'?: string | null;
    /**
     * 
     * @type {TblJalJsonldPrestaRead}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'jal'?: TblJalJsonldPrestaRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'justifLienPublic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'annonceur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'lien'?: string | null;
    /**
     * 
     * @type {TblBodaccJsonldPrestaRead}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'bodacc'?: TblBodaccJsonldPrestaRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'idDocumentAttestation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'exemplaireNb'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'annonce1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'entete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'floId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'coupureDiffusion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'idSTypePresta'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationAnnonceLGaleJsonldPrestaRead
     */
    'dossiers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGalePrestaCoupureDiffusion
 */
export interface PrestationAnnonceLGalePrestaCoupureDiffusion {
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGalePrestaCoupureDiffusion
     */
    'coupureDiffusion'?: boolean;
}
/**
 * 
 * @export
 * @interface PrestationAnnonceLGalePrestaRead
 */
export interface PrestationAnnonceLGalePrestaRead {
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'id'?: number;
    /**
     * 
     * @type {TblDossier2PrestaRead}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'dossier'?: TblDossier2PrestaRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'typePresta'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'dateDemande'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'bouclage'?: string | null;
    /**
     * 
     * @type {TblJalPrestaRead}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'jal'?: TblJalPrestaRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'justifLienPublic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'annonceur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'lien'?: string | null;
    /**
     * 
     * @type {TblBodaccPrestaRead}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'bodacc'?: TblBodaccPrestaRead | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'idDocumentAttestation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'exemplaireNb'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'annonce1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'entete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'floId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'coupureDiffusion'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'idSTypePresta'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrestationAnnonceLGalePrestaRead
     */
    'dossiers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
 */
export interface PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest {
    /**
     * 
     * @type {number}
     * @memberof PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
     */
    'idTiers': number;
    /**
     * 
     * @type {number}
     * @memberof PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest
     */
    'nbExemp': number;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeDetail
 */
export interface TblAnnonceSTypeDetail {
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceSTypeDetail
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetail
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetail
     */
    'abreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetail
     */
    'dirigeant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetail
     */
    'dirigeance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblAnnonceSTypeDetail
     */
    'objetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblAnnonceSTypeDetail
     */
    'capvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblAnnonceSTypeDetail
     */
    'agrement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceSTypeDetail
     */
    'sci'?: number;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeDetailJsonld
 */
export interface TblAnnonceSTypeDetailJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'abreviation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'dirigeant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'dirigeance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'objetDuree'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'capvar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'agrement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceSTypeDetailJsonld
     */
    'sci'?: number;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeSeo
 */
export interface TblAnnonceSTypeSeo {
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceSTypeSeo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeo
     */
    'sType'?: string;
    /**
     * 
     * @type {TblOrigine}
     * @memberof TblAnnonceSTypeSeo
     */
    'origine'?: TblOrigine;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeo
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeo
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeo
     */
    'metaDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeo
     */
    'shortUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceSTypeSeoJsonld
 */
export interface TblAnnonceSTypeSeoJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'sType'?: string;
    /**
     * 
     * @type {TblOrigineJsonld}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'origine'?: TblOrigineJsonld;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'metaDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceSTypeSeoJsonld
     */
    'shortUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceType
 */
export interface TblAnnonceType {
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceType
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceType
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblAnnonceTypeJsonld
 */
export interface TblAnnonceTypeJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblAnnonceTypeJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceTypeJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceTypeJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblAnnonceTypeJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblAnnonceTypeJsonld
     */
    'libelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblBodacc
 */
export interface TblBodacc {
    /**
     * 
     * @type {number}
     * @memberof TblBodacc
     */
    'bdcId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblBodacc
     */
    'bdcFSoumisGtc'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblBodacc
     */
    'bdcStatutTraitementGtc'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodacc
     */
    'bdcLienBodaccAvis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodacc
     */
    'presta'?: string;
}
/**
 * 
 * @export
 * @interface TblBodaccAnnonceLegaleReadJustif
 */
export interface TblBodaccAnnonceLegaleReadJustif {
    /**
     * 
     * @type {number}
     * @memberof TblBodaccAnnonceLegaleReadJustif
     */
    'bdcId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblBodaccAnnonceLegaleReadJustif
     */
    'bdcFSoumisGtc'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccAnnonceLegaleReadJustif
     */
    'bdcStatutTraitementGtc'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccAnnonceLegaleReadJustif
     */
    'bdcLienBodaccAvis'?: string | null;
}
/**
 * 
 * @export
 * @interface TblBodaccJsonld
 */
export interface TblBodaccJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblBodaccJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccJsonld
     */
    'bdcId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblBodaccJsonld
     */
    'bdcFSoumisGtc'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccJsonld
     */
    'bdcStatutTraitementGtc'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonld
     */
    'bdcLienBodaccAvis'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonld
     */
    'presta'?: string;
}
/**
 * 
 * @export
 * @interface TblBodaccJsonldAnnonceLegaleReadJustif
 */
export interface TblBodaccJsonldAnnonceLegaleReadJustif {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    'bdcId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    'bdcFSoumisGtc'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    'bdcStatutTraitementGtc'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonldAnnonceLegaleReadJustif
     */
    'bdcLienBodaccAvis'?: string | null;
}
/**
 * 
 * @export
 * @interface TblBodaccJsonldPrestaRead
 */
export interface TblBodaccJsonldPrestaRead {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblBodaccJsonldPrestaRead
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonldPrestaRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonldPrestaRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccJsonldPrestaRead
     */
    'bdcId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblBodaccJsonldPrestaRead
     */
    'bdcFSoumisGtc'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccJsonldPrestaRead
     */
    'bdcStatutTraitementGtc'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccJsonldPrestaRead
     */
    'bdcLienBodaccAvis'?: string | null;
}
/**
 * 
 * @export
 * @interface TblBodaccPrestaRead
 */
export interface TblBodaccPrestaRead {
    /**
     * 
     * @type {number}
     * @memberof TblBodaccPrestaRead
     */
    'bdcId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblBodaccPrestaRead
     */
    'bdcFSoumisGtc'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblBodaccPrestaRead
     */
    'bdcStatutTraitementGtc'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblBodaccPrestaRead
     */
    'bdcLienBodaccAvis'?: string | null;
}
/**
 * 
 * @export
 * @interface TblCategorie
 */
export interface TblCategorie {
    /**
     * 
     * @type {number}
     * @memberof TblCategorie
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCategorie
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorie
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'prixCommercial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblCategorie
     */
    'idDdm'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'publicationWeb'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'moduleCommande'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'tarifForfait'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'avecSousCategorie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'afficheSousCategorie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'fraisTechnique'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'paiementImpose'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'fraisTechLogo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblCategorie
     */
    'rubriqueAnnonceLegaleOp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorie
     */
    'nombreColonnesPao'?: boolean;
}
/**
 * 
 * @export
 * @interface TblCategorieForfait
 */
export interface TblCategorieForfait {
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'typeTarif'?: number;
    /**
     * 
     * @type {TblCategorie}
     * @memberof TblCategorieForfait
     */
    'categorie'?: TblCategorie;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'sType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'montantForfait'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'montantMajore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'dateDebutApplication'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'dateFinApplication'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieForfait
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfait
     */
    'commentaire'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof TblCategorieForfait
     */
    'dateCreation'?: any;
    /**
     * 
     * @type {TblUtilisateur}
     * @memberof TblCategorieForfait
     */
    'userCreation'?: TblUtilisateur;
    /**
     * 
     * @type {any}
     * @memberof TblCategorieForfait
     */
    'dateLastModif'?: any;
    /**
     * 
     * @type {TblUtilisateur}
     * @memberof TblCategorieForfait
     */
    'userLastModif'?: TblUtilisateur;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA5'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA6'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfait
     */
    'tcfMontantA7'?: number | null;
}
/**
 * 
 * @export
 * @interface TblCategorieForfaitJsonld
 */
export interface TblCategorieForfaitJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblCategorieForfaitJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'typeTarif'?: number;
    /**
     * 
     * @type {TblCategorieJsonld}
     * @memberof TblCategorieForfaitJsonld
     */
    'categorie'?: TblCategorieJsonld;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'sType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'montantForfait'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'montantMajore'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'dateDebutApplication'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'dateFinApplication'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieForfaitJsonld
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieForfaitJsonld
     */
    'commentaire'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof TblCategorieForfaitJsonld
     */
    'dateCreation'?: any;
    /**
     * 
     * @type {TblUtilisateurJsonld}
     * @memberof TblCategorieForfaitJsonld
     */
    'userCreation'?: TblUtilisateurJsonld;
    /**
     * 
     * @type {any}
     * @memberof TblCategorieForfaitJsonld
     */
    'dateLastModif'?: any;
    /**
     * 
     * @type {TblUtilisateurJsonld}
     * @memberof TblCategorieForfaitJsonld
     */
    'userLastModif'?: TblUtilisateurJsonld;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA5'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA6'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieForfaitJsonld
     */
    'tcfMontantA7'?: number | null;
}
/**
 * 
 * @export
 * @interface TblCategorieJsonld
 */
export interface TblCategorieJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblCategorieJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieJsonld
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'prixCommercial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblCategorieJsonld
     */
    'idDdm'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'publicationWeb'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'moduleCommande'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'tarifForfait'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'avecSousCategorie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'afficheSousCategorie'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'fraisTechnique'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'paiementImpose'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'fraisTechLogo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblCategorieJsonld
     */
    'rubriqueAnnonceLegaleOp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblCategorieJsonld
     */
    'nombreColonnesPao'?: boolean;
}
/**
 * 
 * @export
 * @interface TblDossier2
 */
export interface TblDossier2 {
    /**
     * 
     * @type {number}
     * @memberof TblDossier2
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {TblTiers}
     * @memberof TblDossier2
     */
    'prescripteur'?: TblTiers | null;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2
     */
    'numero'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2
     */
    'statut'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2
     */
    'refCdeClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2
     */
    'tht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2
     */
    'tva'?: string | null;
}
/**
 * 
 * @export
 * @interface TblDossier2Jsonld
 */
export interface TblDossier2Jsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblDossier2Jsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2Jsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2Jsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2Jsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2Jsonld
     */
    'idSociete'?: number | null;
    /**
     * 
     * @type {TblTiersJsonld}
     * @memberof TblDossier2Jsonld
     */
    'prescripteur'?: TblTiersJsonld | null;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2Jsonld
     */
    'numero'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2Jsonld
     */
    'statut'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2Jsonld
     */
    'refCdeClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2Jsonld
     */
    'tht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2Jsonld
     */
    'tva'?: string | null;
}
/**
 * 
 * @export
 * @interface TblDossier2JsonldPrestaRead
 */
export interface TblDossier2JsonldPrestaRead {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblDossier2JsonldPrestaRead
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPrestaRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPrestaRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2JsonldPrestaRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2JsonldPrestaRead
     */
    'statut'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPrestaRead
     */
    'refCdeClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPrestaRead
     */
    'tht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPrestaRead
     */
    'tva'?: string | null;
}
/**
 * 
 * @export
 * @interface TblDossier2PrestaRead
 */
export interface TblDossier2PrestaRead {
    /**
     * 
     * @type {number}
     * @memberof TblDossier2PrestaRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2PrestaRead
     */
    'statut'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2PrestaRead
     */
    'refCdeClient'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2PrestaRead
     */
    'tht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2PrestaRead
     */
    'tva'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFormulaire
 */
export interface TblFormulaire {
    /**
     * 
     * @type {number}
     * @memberof TblFormulaire
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFormulaire
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFormulaire
     */
    'deleted'?: number | null;
}
/**
 * 
 * @export
 * @interface TblFormulaireJsonld
 */
export interface TblFormulaireJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblFormulaireJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFormulaireJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFormulaireJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFormulaireJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFormulaireJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFormulaireJsonld
     */
    'deleted'?: number | null;
}
/**
 * 
 * @export
 * @interface TblJal
 */
export interface TblJal {
    /**
     * 
     * @type {number}
     * @memberof TblJal
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblJal
     */
    'nom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblJal
     */
    'fCoupureDiffusion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblJal
     */
    'nbJoursCoupureDiffusion'?: number | null;
}
/**
 * 
 * @export
 * @interface TblJalJsonld
 */
export interface TblJalJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblJalJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblJalJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblJalJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblJalJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblJalJsonld
     */
    'nom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblJalJsonld
     */
    'fCoupureDiffusion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblJalJsonld
     */
    'nbJoursCoupureDiffusion'?: number | null;
}
/**
 * 
 * @export
 * @interface TblJalJsonldPrestaRead
 */
export interface TblJalJsonldPrestaRead {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblJalJsonldPrestaRead
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblJalJsonldPrestaRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblJalJsonldPrestaRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblJalJsonldPrestaRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblJalJsonldPrestaRead
     */
    'nom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblJalJsonldPrestaRead
     */
    'fCoupureDiffusion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblJalJsonldPrestaRead
     */
    'nbJoursCoupureDiffusion'?: number | null;
}
/**
 * 
 * @export
 * @interface TblJalPrestaRead
 */
export interface TblJalPrestaRead {
    /**
     * 
     * @type {number}
     * @memberof TblJalPrestaRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblJalPrestaRead
     */
    'nom'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblJalPrestaRead
     */
    'fCoupureDiffusion'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblJalPrestaRead
     */
    'nbJoursCoupureDiffusion'?: number | null;
}
/**
 * 
 * @export
 * @interface TblOrigine
 */
export interface TblOrigine {
    /**
     * 
     * @type {number}
     * @memberof TblOrigine
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblOrigine
     */
    'origine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblOrigine
     */
    'initiale'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblOrigine
     */
    'societe'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblOrigine
     */
    'baseUrl'?: string;
}
/**
 * 
 * @export
 * @interface TblOrigineJsonld
 */
export interface TblOrigineJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblOrigineJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblOrigineJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblOrigineJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblOrigineJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblOrigineJsonld
     */
    'origine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblOrigineJsonld
     */
    'initiale'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblOrigineJsonld
     */
    'societe'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblOrigineJsonld
     */
    'baseUrl'?: string;
}
/**
 * 
 * @export
 * @interface TblRelationSTypeDetail
 */
export interface TblRelationSTypeDetail {
    /**
     * 
     * @type {number}
     * @memberof TblRelationSTypeDetail
     */
    'id'?: number;
    /**
     * 
     * @type {TblAnnonceSTypeDetail}
     * @memberof TblRelationSTypeDetail
     */
    'sTypeDetail'?: TblAnnonceSTypeDetail;
    /**
     * 
     * @type {string}
     * @memberof TblRelationSTypeDetail
     */
    'sType'?: string;
}
/**
 * 
 * @export
 * @interface TblRelationSTypeDetailJsonld
 */
export interface TblRelationSTypeDetailJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblRelationSTypeDetailJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblRelationSTypeDetailJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblRelationSTypeDetailJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblRelationSTypeDetailJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {TblAnnonceSTypeDetailJsonld}
     * @memberof TblRelationSTypeDetailJsonld
     */
    'sTypeDetail'?: TblAnnonceSTypeDetailJsonld;
    /**
     * 
     * @type {string}
     * @memberof TblRelationSTypeDetailJsonld
     */
    'sType'?: string;
}
/**
 * 
 * @export
 * @interface TblRelationStypeOrigine
 */
export interface TblRelationStypeOrigine {
    /**
     * 
     * @type {number}
     * @memberof TblRelationStypeOrigine
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblRelationStypeOrigine
     */
    'sType'?: string;
    /**
     * 
     * @type {TblOrigine}
     * @memberof TblRelationStypeOrigine
     */
    'origine'?: TblOrigine;
    /**
     * 
     * @type {number}
     * @memberof TblRelationStypeOrigine
     */
    'main'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblRelationStypeOrigine
     */
    'recherche'?: number;
}
/**
 * 
 * @export
 * @interface TblRelationStypeOrigineJsonld
 */
export interface TblRelationStypeOrigineJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblRelationStypeOrigineJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblRelationStypeOrigineJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblRelationStypeOrigineJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblRelationStypeOrigineJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblRelationStypeOrigineJsonld
     */
    'sType'?: string;
    /**
     * 
     * @type {TblOrigineJsonld}
     * @memberof TblRelationStypeOrigineJsonld
     */
    'origine'?: TblOrigineJsonld;
    /**
     * 
     * @type {number}
     * @memberof TblRelationStypeOrigineJsonld
     */
    'main'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblRelationStypeOrigineJsonld
     */
    'recherche'?: number;
}
/**
 * 
 * @export
 * @interface TblTiers
 */
export interface TblTiers {
    /**
     * 
     * @type {number}
     * @memberof TblTiers
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTiers
     */
    'raisonSociale'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblTiers
     */
    'formaliste'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTiers
     */
    'demo'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblTiersJsonld
 */
export interface TblTiersJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblTiersJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblTiersJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblTiersJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblTiersJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblTiersJsonld
     */
    'raisonSociale'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblTiersJsonld
     */
    'formaliste'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblTiersJsonld
     */
    'demo'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblUtilisateur
 */
export interface TblUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'password'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'idUserGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'initiales'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'user'?: string | null;
    /**
     * 
     * @type {TblUtilisateur}
     * @memberof TblUtilisateur
     */
    'userMAJ'?: TblUtilisateur | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'dateMAJ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'poste'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'eleveur'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'groupe'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'g3'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'societe'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'vpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'g3Recetteur'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'comptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateur
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'idUserDematFacile'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateur
     */
    'idMarque'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'fpro'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateur
     */
    'inAnnuaire'?: boolean;
}
/**
 * 
 * @export
 * @interface TblUtilisateurJsonld
 */
export interface TblUtilisateurJsonld {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TblUtilisateurJsonld
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'password'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'idUserGroupe'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'initiales'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'user'?: string | null;
    /**
     * 
     * @type {TblUtilisateurJsonld}
     * @memberof TblUtilisateurJsonld
     */
    'userMAJ'?: TblUtilisateurJsonld | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'dateMAJ'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'poste'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'ligneDirecte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'mail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'pc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'eleveur'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'groupe'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'g3'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'societe'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'portable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'fonction'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'vpn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'g3Recetteur'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'idUserG3'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'comptaSoftware'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblUtilisateurJsonld
     */
    'dematFacile'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'idUserDematFacile'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblUtilisateurJsonld
     */
    'idMarque'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'fpro'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblUtilisateurJsonld
     */
    'inAnnuaire'?: boolean;
}
/**
 * 
 * @export
 * @interface TypeAnnonceLegaleReadCollection
 */
export interface TypeAnnonceLegaleReadCollection {
    /**
     * 
     * @type {number}
     * @memberof TypeAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeAnnonceLegaleReadCollection
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface TypeAnnonceLegaleReadItem
 */
export interface TypeAnnonceLegaleReadItem {
    /**
     * 
     * @type {number}
     * @memberof TypeAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeAnnonceLegaleReadItem
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface TypeJsonldAnnonceLegaleReadCollection
 */
export interface TypeJsonldAnnonceLegaleReadCollection {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TypeJsonldAnnonceLegaleReadCollection
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TypeJsonldAnnonceLegaleReadCollection
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeJsonldAnnonceLegaleReadCollection
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TypeJsonldAnnonceLegaleReadCollection
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeJsonldAnnonceLegaleReadCollection
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface TypeJsonldAnnonceLegaleReadItem
 */
export interface TypeJsonldAnnonceLegaleReadItem {
    /**
     * 
     * @type {AnnonceLGaleTraitementDeStatutsJsonldContext}
     * @memberof TypeJsonldAnnonceLegaleReadItem
     */
    '@context'?: AnnonceLGaleTraitementDeStatutsJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TypeJsonldAnnonceLegaleReadItem
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeJsonldAnnonceLegaleReadItem
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TypeJsonldAnnonceLegaleReadItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeJsonldAnnonceLegaleReadItem
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface TypesAnnoncesLegalesParOrigine
 */
export interface TypesAnnoncesLegalesParOrigine {
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'IDSType'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'IDOrigine': number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'flg_main'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'IDTypeAnnonce'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'TypeAnnonce'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'type_libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'shorturl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'TypeSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'libellepardef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'abreviationtypedetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'listestypedetail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'libreonly'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'idformulaire'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'b2babre'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'rang'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'f_actif'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'metadescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'f_spelaccepte'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'F_Tarif_Forfait'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'iDSType'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'iDOrigine'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'flgMain'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'iDTypeAnnonce'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'typeAnnonce'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'typeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'typeSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'factif'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'fspelaccepte'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigine
     */
    'fTarifForfait'?: number | null;
}
/**
 * 
 * @export
 * @interface TypesAnnoncesLegalesParOrigineJsonld
 */
export interface TypesAnnoncesLegalesParOrigineJsonld {
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'IDSType'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'IDOrigine': number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'flg_main'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'IDTypeAnnonce'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'TypeAnnonce'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'type_libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'shorturl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'TypeSociete'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'libellepardef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'abreviationtypedetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'listestypedetail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'libreonly'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'idformulaire'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'b2babre'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'rang'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'f_actif'?: number;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'metadescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'f_spelaccepte'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'F_Tarif_Forfait'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'iDSType'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'iDOrigine'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'flgMain'?: number;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'iDTypeAnnonce'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'typeAnnonce'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'typeLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'typeSociete'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'factif'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'fspelaccepte'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineJsonld
     */
    'fTarifForfait'?: number | null;
}

/**
 * AnnonceLgaleTraitementDeStatutsApi - axios parameter creator
 * @export
 */
export const AnnonceLgaleTraitementDeStatutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Envoie un ou plusieurs statuts (PDF, DOCX, etc.) ainsi que les métadonnées associées vers un webhook n8n pour traitement automatisé.
         * @summary Soumettre des statuts pour traitement via webhook n8n
         * @param {Array<File>} documents Un ou plusieurs fichiers de statuts à traiter (PDF, DOCX, DOC, ODT, etc.)
         * @param {string} refClient Référence client - obligatoire
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [typeAnnonce] L\\\&#39;identifiant du sous-type d\\\&#39;annonce légale (IDSType) - optionnel
         * @param {string} [departement] Le code du département (ex: 75, 69, 13) - optionnel
         * @param {string} [callbackUrl] L\\\&#39;URL de callback à appeler une fois le traitement terminé - optionnel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection: async (documents: Array<File>, refClient: string, xIdSociete?: number, typeAnnonce?: number, departement?: string, callbackUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documents' is not null or undefined
            assertParamExists('postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection', 'documents', documents)
            // verify required parameter 'refClient' is not null or undefined
            assertParamExists('postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection', 'refClient', refClient)
            const localVarPath = `/annonces-legales/traitement-statuts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }

            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

    
            if (refClient !== undefined) { 
                localVarFormParams.append('refClient', refClient as any);
            }
    
            if (typeAnnonce !== undefined) { 
                localVarFormParams.append('typeAnnonce', typeAnnonce as any);
            }
    
            if (departement !== undefined) { 
                localVarFormParams.append('departement', departement as any);
            }
    
            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnonceLgaleTraitementDeStatutsApi - functional programming interface
 * @export
 */
export const AnnonceLgaleTraitementDeStatutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnonceLgaleTraitementDeStatutsApiAxiosParamCreator(configuration)
    return {
        /**
         * Envoie un ou plusieurs statuts (PDF, DOCX, etc.) ainsi que les métadonnées associées vers un webhook n8n pour traitement automatisé.
         * @summary Soumettre des statuts pour traitement via webhook n8n
         * @param {Array<File>} documents Un ou plusieurs fichiers de statuts à traiter (PDF, DOCX, DOC, ODT, etc.)
         * @param {string} refClient Référence client - obligatoire
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [typeAnnonce] L\\\&#39;identifiant du sous-type d\\\&#39;annonce légale (IDSType) - optionnel
         * @param {string} [departement] Le code du département (ex: 75, 69, 13) - optionnel
         * @param {string} [callbackUrl] L\\\&#39;URL de callback à appeler une fois le traitement terminé - optionnel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection(documents: Array<File>, refClient: string, xIdSociete?: number, typeAnnonce?: number, departement?: string, callbackUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnonceLGaleTraitementDeStatutsJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection(documents, refClient, xIdSociete, typeAnnonce, departement, callbackUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnonceLgaleTraitementDeStatutsApi.postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnnonceLgaleTraitementDeStatutsApi - factory interface
 * @export
 */
export const AnnonceLgaleTraitementDeStatutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnonceLgaleTraitementDeStatutsApiFp(configuration)
    return {
        /**
         * Envoie un ou plusieurs statuts (PDF, DOCX, etc.) ainsi que les métadonnées associées vers un webhook n8n pour traitement automatisé.
         * @summary Soumettre des statuts pour traitement via webhook n8n
         * @param {AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection(requestParameters: AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnnonceLGaleTraitementDeStatutsJsonld> {
            return localVarFp.postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection(requestParameters.documents, requestParameters.refClient, requestParameters.xIdSociete, requestParameters.typeAnnonce, requestParameters.departement, requestParameters.callbackUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection operation in AnnonceLgaleTraitementDeStatutsApi.
 * @export
 * @interface AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollectionRequest
 */
export interface AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollectionRequest {
    /**
     * Un ou plusieurs fichiers de statuts à traiter (PDF, DOCX, DOC, ODT, etc.)
     * @type {Array<File>}
     * @memberof AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection
     */
    readonly documents: Array<File>

    /**
     * Référence client - obligatoire
     * @type {string}
     * @memberof AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection
     */
    readonly refClient: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection
     */
    readonly xIdSociete?: number

    /**
     * L\\\&#39;identifiant du sous-type d\\\&#39;annonce légale (IDSType) - optionnel
     * @type {number}
     * @memberof AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection
     */
    readonly typeAnnonce?: number

    /**
     * Le code du département (ex: 75, 69, 13) - optionnel
     * @type {string}
     * @memberof AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection
     */
    readonly departement?: string

    /**
     * L\\\&#39;URL de callback à appeler une fois le traitement terminé - optionnel
     * @type {string}
     * @memberof AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection
     */
    readonly callbackUrl?: string
}

/**
 * AnnonceLgaleTraitementDeStatutsApi - object-oriented interface
 * @export
 * @class AnnonceLgaleTraitementDeStatutsApi
 * @extends {BaseAPI}
 */
export class AnnonceLgaleTraitementDeStatutsApi extends BaseAPI {
    /**
     * Envoie un ou plusieurs statuts (PDF, DOCX, etc.) ainsi que les métadonnées associées vers un webhook n8n pour traitement automatisé.
     * @summary Soumettre des statuts pour traitement via webhook n8n
     * @param {AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnonceLgaleTraitementDeStatutsApi
     */
    public postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection(requestParameters: AnnonceLgaleTraitementDeStatutsApiPostTraitementStatutsAnnonceLgaleTraitementDeStatutsCollectionRequest, options?: RawAxiosRequestConfig) {
        return AnnonceLgaleTraitementDeStatutsApiFp(this.configuration).postTraitementStatutsAnnonceLgaleTraitementDeStatutsCollection(requestParameters.documents, requestParameters.refClient, requestParameters.xIdSociete, requestParameters.typeAnnonce, requestParameters.departement, requestParameters.callbackUrl, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnnoncesLegalesApi - axios parameter creator
 * @export
 */
export const AnnoncesLegalesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer les détails d\'un type d\'annonce légale
         * @summary Récupérer les détails d\'un type d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnonceLegaleAnnonceLegaleItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAnnonceLegaleAnnonceLegaleItem', 'id', id)
            const localVarPath = `/annonces-legales/annonces-legales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer la liste des types d\'annonces légales
         * @summary Récupérer la liste des types d\'annonces légales
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [origine] 
         * @param {Array<number>} [origine2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListAnnoncesLegalesAnnonceLegaleCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, origine?: number, origine2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/annonces-legales/annonces-legales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (origine !== undefined) {
                localVarQueryParameter['origine'] = origine;
            }

            if (origine2) {
                localVarQueryParameter['origine[]'] = origine2;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
         * @summary Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
         * @param {number} nTopResults Nombre de résultat voulu dans le top de la liste
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection: async (nTopResults: number, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nTopResults' is not null or undefined
            assertParamExists('getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection', 'nTopResults', nTopResults)
            const localVarPath = `/annonces-legales/annonces-legales/palmares_stype/{nTopResults}`
                .replace(`{${"nTopResults"}}`, encodeURIComponent(String(nTopResults)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne le nom du support et les prochaines dates de parution via la procédure Parution3Mois
         * @summary Dates de parution sur 3 mois pour une édition JAL
         * @param {number} idjaledition Identifiant de l\&#39;édition JAL
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParutionsJalEditionAnnonceLegaleCollection: async (idjaledition: number, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idjaledition' is not null or undefined
            assertParamExists('getParutionsJalEditionAnnonceLegaleCollection', 'idjaledition', idjaledition)
            const localVarPath = `/annonces-legales/parutions/{idjaledition}`
                .replace(`{${"idjaledition"}}`, encodeURIComponent(String(idjaledition)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne le mode de tarification applicable (au caractère, au forfait, DNID ou journal officiel) pour un sous-type d\'annonce, un département et une date donnés
         * @summary Récupérer les informations de tarification d\'un sous-type d\'annonce
         * @param {number} id L\&#39;ID du sous type
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {string} [departmentCode] Code departement
         * @param {string} [date] date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingAnnonceLegaleItem: async (id: number, xIdSociete?: number, departmentCode?: string, date?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPricingAnnonceLegaleItem', 'id', id)
            const localVarPath = `/annonces-legales/tarification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (departmentCode !== undefined) {
                localVarQueryParameter['departmentCode'] = departmentCode;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupere les informations de tarification par sous type
         * @summary Récupere les informations de tarification par sous type
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {string} [departmentCode] Code departement
         * @param {string} [date] date
         * @param {number} [page] The collection page number
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [origine] 
         * @param {Array<number>} [origine2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingsAnnonceLegaleCollection: async (xIdSociete?: number, departmentCode?: string, date?: string, page?: number, id?: number, id2?: Array<number>, origine?: number, origine2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/annonces-legales/tarification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (departmentCode !== undefined) {
                localVarQueryParameter['departmentCode'] = departmentCode;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (origine !== undefined) {
                localVarQueryParameter['origine'] = origine;
            }

            if (origine2) {
                localVarQueryParameter['origine[]'] = origine2;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne les supports JAL disponibles pour un département et un sous-type d\'annonce, via la procédure ws_Dep_JAL
         * @summary Lister les supports JAL disponibles
         * @param {string} dep Code géographique du département (CODGEO)
         * @param {number} idSType Identifiant du sous-type d\&#39;annonce (IDSType)
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAnnonceLegaleCollection: async (dep: string, idSType: number, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dep' is not null or undefined
            assertParamExists('getSupportAnnonceLegaleCollection', 'dep', dep)
            // verify required parameter 'idSType' is not null or undefined
            assertParamExists('getSupportAnnonceLegaleCollection', 'idSType', idSType)
            const localVarPath = `/annonces-legales/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (dep !== undefined) {
                localVarQueryParameter['dep'] = dep;
            }

            if (idSType !== undefined) {
                localVarQueryParameter['idSType'] = idSType;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Annule une annonce légale via le webservice SOAP WS Client Ext (SET_AnnuleAnnonce)
         * @summary Annuler une annonce légale
         * @param {number} id Identifiant de la prestation
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnnuleAnnonceLegaleAnnonceLegaleItem: async (id: number, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAnnuleAnnonceLegaleAnnonceLegaleItem', 'id', id)
            const localVarPath = `/annonces-legales/annonces-legales/{id}/annulation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transmet la saisie d\'une nouvelle annonce légale
         * @summary Créer une annonce légale
         * @param {PostAnnonceLegaleAnnonceLegaleCollectionRequest} postAnnonceLegaleAnnonceLegaleCollectionRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnnonceLegaleAnnonceLegaleCollection: async (postAnnonceLegaleAnnonceLegaleCollectionRequest: PostAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postAnnonceLegaleAnnonceLegaleCollectionRequest' is not null or undefined
            assertParamExists('postAnnonceLegaleAnnonceLegaleCollection', 'postAnnonceLegaleAnnonceLegaleCollectionRequest', postAnnonceLegaleAnnonceLegaleCollectionRequest)
            const localVarPath = `/annonces-legales/annonces-legales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAnnonceLegaleAnnonceLegaleCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calcule le tarif d\'une annonce légale sans la sauvegarder
         * @summary Calculer le prix d\'une annonce légale
         * @param {PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest} postPrixAnnonceLegaleAnnonceLegaleCollectionRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPrixAnnonceLegaleAnnonceLegaleCollection: async (postPrixAnnonceLegaleAnnonceLegaleCollectionRequest: PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postPrixAnnonceLegaleAnnonceLegaleCollectionRequest' is not null or undefined
            assertParamExists('postPrixAnnonceLegaleAnnonceLegaleCollection', 'postPrixAnnonceLegaleAnnonceLegaleCollectionRequest', postPrixAnnonceLegaleAnnonceLegaleCollectionRequest)
            const localVarPath = `/annonces-legales/annonces-legales/prix`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPrixAnnonceLegaleAnnonceLegaleCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transmet la mise à jour d\'une annonce légale
         * @summary Mettre à jour une annonce légale
         * @param {number} id Identifiant de la prestation
         * @param {PostAnnonceLegaleAnnonceLegaleCollectionRequest} postAnnonceLegaleAnnonceLegaleCollectionRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAnnonceLegaleAnnonceLegaleItem: async (id: number, postAnnonceLegaleAnnonceLegaleCollectionRequest: PostAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putAnnonceLegaleAnnonceLegaleItem', 'id', id)
            // verify required parameter 'postAnnonceLegaleAnnonceLegaleCollectionRequest' is not null or undefined
            assertParamExists('putAnnonceLegaleAnnonceLegaleItem', 'postAnnonceLegaleAnnonceLegaleCollectionRequest', postAnnonceLegaleAnnonceLegaleCollectionRequest)
            const localVarPath = `/annonces-legales/annonces-legales/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAnnonceLegaleAnnonceLegaleCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnnoncesLegalesApi - functional programming interface
 * @export
 */
export const AnnoncesLegalesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnnoncesLegalesApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer les détails d\'un type d\'annonce légale
         * @summary Récupérer les détails d\'un type d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnnonceLegaleAnnonceLegaleItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnnonceLegaleAnnonceLegaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getAnnonceLegaleAnnonceLegaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer la liste des types d\'annonces légales
         * @summary Récupérer la liste des types d\'annonces légales
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [origine] 
         * @param {Array<number>} [origine2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListAnnoncesLegalesAnnonceLegaleCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, id?: number, id2?: Array<number>, origine?: number, origine2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListAnnoncesLegalesAnnonceLegaleCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListAnnoncesLegalesAnnonceLegaleCollection(xIdSociete, page, itemsPerPage, id, id2, origine, origine2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getListAnnoncesLegalesAnnonceLegaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
         * @summary Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
         * @param {number} nTopResults Nombre de résultat voulu dans le top de la liste
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection(nTopResults: number, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection(nTopResults, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retourne le nom du support et les prochaines dates de parution via la procédure Parution3Mois
         * @summary Dates de parution sur 3 mois pour une édition JAL
         * @param {number} idjaledition Identifiant de l\&#39;édition JAL
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParutionsJalEditionAnnonceLegaleCollection(idjaledition: number, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetParutionsJalEditionAnnonceLegaleCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParutionsJalEditionAnnonceLegaleCollection(idjaledition, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getParutionsJalEditionAnnonceLegaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retourne le mode de tarification applicable (au caractère, au forfait, DNID ou journal officiel) pour un sous-type d\'annonce, un département et une date donnés
         * @summary Récupérer les informations de tarification d\'un sous-type d\'annonce
         * @param {number} id L\&#39;ID du sous type
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {string} [departmentCode] Code departement
         * @param {string} [date] date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricingAnnonceLegaleItem(id: number, xIdSociete?: number, departmentCode?: string, date?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPricingAnnonceLegaleItem200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingAnnonceLegaleItem(id, xIdSociete, departmentCode, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getPricingAnnonceLegaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupere les informations de tarification par sous type
         * @summary Récupere les informations de tarification par sous type
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {string} [departmentCode] Code departement
         * @param {string} [date] date
         * @param {number} [page] The collection page number
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [origine] 
         * @param {Array<number>} [origine2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricingsAnnonceLegaleCollection(xIdSociete?: number, departmentCode?: string, date?: string, page?: number, id?: number, id2?: Array<number>, origine?: number, origine2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPricingsAnnonceLegaleCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingsAnnonceLegaleCollection(xIdSociete, departmentCode, date, page, id, id2, origine, origine2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getPricingsAnnonceLegaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retourne les supports JAL disponibles pour un département et un sous-type d\'annonce, via la procédure ws_Dep_JAL
         * @summary Lister les supports JAL disponibles
         * @param {string} dep Code géographique du département (CODGEO)
         * @param {number} idSType Identifiant du sous-type d\&#39;annonce (IDSType)
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportAnnonceLegaleCollection(dep: string, idSType: number, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSupportAnnonceLegaleCollection200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportAnnonceLegaleCollection(dep, idSType, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.getSupportAnnonceLegaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Annule une annonce légale via le webservice SOAP WS Client Ext (SET_AnnuleAnnonce)
         * @summary Annuler une annonce légale
         * @param {number} id Identifiant de la prestation
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAnnuleAnnonceLegaleAnnonceLegaleItem(id: number, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchAnnuleAnnonceLegaleAnnonceLegaleItem200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAnnuleAnnonceLegaleAnnonceLegaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.patchAnnuleAnnonceLegaleAnnonceLegaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transmet la saisie d\'une nouvelle annonce légale
         * @summary Créer une annonce légale
         * @param {PostAnnonceLegaleAnnonceLegaleCollectionRequest} postAnnonceLegaleAnnonceLegaleCollectionRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAnnonceLegaleAnnonceLegaleCollection(postAnnonceLegaleAnnonceLegaleCollectionRequest: PostAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAnnonceLegaleAnnonceLegaleCollection201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAnnonceLegaleAnnonceLegaleCollection(postAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.postAnnonceLegaleAnnonceLegaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calcule le tarif d\'une annonce légale sans la sauvegarder
         * @summary Calculer le prix d\'une annonce légale
         * @param {PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest} postPrixAnnonceLegaleAnnonceLegaleCollectionRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPrixAnnonceLegaleAnnonceLegaleCollection(postPrixAnnonceLegaleAnnonceLegaleCollectionRequest: PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPrixAnnonceLegaleAnnonceLegaleCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPrixAnnonceLegaleAnnonceLegaleCollection(postPrixAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.postPrixAnnonceLegaleAnnonceLegaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transmet la mise à jour d\'une annonce légale
         * @summary Mettre à jour une annonce légale
         * @param {number} id Identifiant de la prestation
         * @param {PostAnnonceLegaleAnnonceLegaleCollectionRequest} postAnnonceLegaleAnnonceLegaleCollectionRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putAnnonceLegaleAnnonceLegaleItem(id: number, postAnnonceLegaleAnnonceLegaleCollectionRequest: PostAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAnnonceLegaleAnnonceLegaleCollection201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putAnnonceLegaleAnnonceLegaleItem(id, postAnnonceLegaleAnnonceLegaleCollectionRequest, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnnoncesLegalesApi.putAnnonceLegaleAnnonceLegaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnnoncesLegalesApi - factory interface
 * @export
 */
export const AnnoncesLegalesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnnoncesLegalesApiFp(configuration)
    return {
        /**
         * Récupérer les détails d\'un type d\'annonce légale
         * @summary Récupérer les détails d\'un type d\'annonce légale
         * @param {AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnonceLegaleAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnnonceLegaleAnnonceLegaleJsonldAnnonceLegaleReadItem> {
            return localVarFp.getAnnonceLegaleAnnonceLegaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer la liste des types d\'annonces légales
         * @summary Récupérer la liste des types d\'annonces légales
         * @param {AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListAnnoncesLegalesAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetListAnnoncesLegalesAnnonceLegaleCollection200Response> {
            return localVarFp.getListAnnoncesLegalesAnnonceLegaleCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.origine, requestParameters.origine2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
         * @summary Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
         * @param {AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection(requestParameters: AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection200ResponseInner>> {
            return localVarFp.getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection(requestParameters.nTopResults, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retourne le nom du support et les prochaines dates de parution via la procédure Parution3Mois
         * @summary Dates de parution sur 3 mois pour une édition JAL
         * @param {AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParutionsJalEditionAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetParutionsJalEditionAnnonceLegaleCollection200Response> {
            return localVarFp.getParutionsJalEditionAnnonceLegaleCollection(requestParameters.idjaledition, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retourne le mode de tarification applicable (au caractère, au forfait, DNID ou journal officiel) pour un sous-type d\'annonce, un département et une date donnés
         * @summary Récupérer les informations de tarification d\'un sous-type d\'annonce
         * @param {AnnoncesLegalesApiGetPricingAnnonceLegaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiGetPricingAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPricingAnnonceLegaleItem200Response> {
            return localVarFp.getPricingAnnonceLegaleItem(requestParameters.id, requestParameters.xIdSociete, requestParameters.departmentCode, requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupere les informations de tarification par sous type
         * @summary Récupere les informations de tarification par sous type
         * @param {AnnoncesLegalesApiGetPricingsAnnonceLegaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingsAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetPricingsAnnonceLegaleCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetPricingsAnnonceLegaleCollection200Response> {
            return localVarFp.getPricingsAnnonceLegaleCollection(requestParameters.xIdSociete, requestParameters.departmentCode, requestParameters.date, requestParameters.page, requestParameters.id, requestParameters.id2, requestParameters.origine, requestParameters.origine2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retourne les supports JAL disponibles pour un département et un sous-type d\'annonce, via la procédure ws_Dep_JAL
         * @summary Lister les supports JAL disponibles
         * @param {AnnoncesLegalesApiGetSupportAnnonceLegaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetSupportAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetSupportAnnonceLegaleCollection200ResponseInner>> {
            return localVarFp.getSupportAnnonceLegaleCollection(requestParameters.dep, requestParameters.idSType, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Annule une annonce légale via le webservice SOAP WS Client Ext (SET_AnnuleAnnonce)
         * @summary Annuler une annonce légale
         * @param {AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnnuleAnnonceLegaleAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchAnnuleAnnonceLegaleAnnonceLegaleItem200Response> {
            return localVarFp.patchAnnuleAnnonceLegaleAnnonceLegaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Transmet la saisie d\'une nouvelle annonce légale
         * @summary Créer une annonce légale
         * @param {AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAnnonceLegaleAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostAnnonceLegaleAnnonceLegaleCollection201Response> {
            return localVarFp.postAnnonceLegaleAnnonceLegaleCollection(requestParameters.postAnnonceLegaleAnnonceLegaleCollectionRequest, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Calcule le tarif d\'une annonce légale sans la sauvegarder
         * @summary Calculer le prix d\'une annonce légale
         * @param {AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPrixAnnonceLegaleAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostPrixAnnonceLegaleAnnonceLegaleCollection200Response> {
            return localVarFp.postPrixAnnonceLegaleAnnonceLegaleCollection(requestParameters.postPrixAnnonceLegaleAnnonceLegaleCollectionRequest, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Transmet la mise à jour d\'une annonce légale
         * @summary Mettre à jour une annonce légale
         * @param {AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAnnonceLegaleAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostAnnonceLegaleAnnonceLegaleCollection201Response> {
            return localVarFp.putAnnonceLegaleAnnonceLegaleItem(requestParameters.id, requestParameters.postAnnonceLegaleAnnonceLegaleCollectionRequest, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAnnonceLegaleAnnonceLegaleItem operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItemRequest
 */
export interface AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getListAnnoncesLegalesAnnonceLegaleCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollectionRequest
 */
export interface AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly id2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly origine?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollection
     */
    readonly origine2?: Array<number>
}

/**
 * Request parameters for getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollectionRequest
 */
export interface AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollectionRequest {
    /**
     * Nombre de résultat voulu dans le top de la liste
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection
     */
    readonly nTopResults: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollection
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getParutionsJalEditionAnnonceLegaleCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollectionRequest
 */
export interface AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollectionRequest {
    /**
     * Identifiant de l\&#39;édition JAL
     * @type {number}
     * @memberof AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollection
     */
    readonly idjaledition: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollection
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getPricingAnnonceLegaleItem operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetPricingAnnonceLegaleItemRequest
 */
export interface AnnoncesLegalesApiGetPricingAnnonceLegaleItemRequest {
    /**
     * L\&#39;ID du sous type
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPricingAnnonceLegaleItem
     */
    readonly id: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPricingAnnonceLegaleItem
     */
    readonly xIdSociete?: number

    /**
     * Code departement
     * @type {string}
     * @memberof AnnoncesLegalesApiGetPricingAnnonceLegaleItem
     */
    readonly departmentCode?: string

    /**
     * date
     * @type {string}
     * @memberof AnnoncesLegalesApiGetPricingAnnonceLegaleItem
     */
    readonly date?: string
}

/**
 * Request parameters for getPricingsAnnonceLegaleCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetPricingsAnnonceLegaleCollectionRequest
 */
export interface AnnoncesLegalesApiGetPricingsAnnonceLegaleCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly xIdSociete?: number

    /**
     * Code departement
     * @type {string}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly departmentCode?: string

    /**
     * date
     * @type {string}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly date?: string

    /**
     * The collection page number
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly id2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly origine?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AnnoncesLegalesApiGetPricingsAnnonceLegaleCollection
     */
    readonly origine2?: Array<number>
}

/**
 * Request parameters for getSupportAnnonceLegaleCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiGetSupportAnnonceLegaleCollectionRequest
 */
export interface AnnoncesLegalesApiGetSupportAnnonceLegaleCollectionRequest {
    /**
     * Code géographique du département (CODGEO)
     * @type {string}
     * @memberof AnnoncesLegalesApiGetSupportAnnonceLegaleCollection
     */
    readonly dep: string

    /**
     * Identifiant du sous-type d\&#39;annonce (IDSType)
     * @type {number}
     * @memberof AnnoncesLegalesApiGetSupportAnnonceLegaleCollection
     */
    readonly idSType: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiGetSupportAnnonceLegaleCollection
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for patchAnnuleAnnonceLegaleAnnonceLegaleItem operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItemRequest
 */
export interface AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItemRequest {
    /**
     * Identifiant de la prestation
     * @type {number}
     * @memberof AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItem
     */
    readonly id: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for postAnnonceLegaleAnnonceLegaleCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollectionRequest
 */
export interface AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollectionRequest {
    /**
     * 
     * @type {PostAnnonceLegaleAnnonceLegaleCollectionRequest}
     * @memberof AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollection
     */
    readonly postAnnonceLegaleAnnonceLegaleCollectionRequest: PostAnnonceLegaleAnnonceLegaleCollectionRequest

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollection
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for postPrixAnnonceLegaleAnnonceLegaleCollection operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollectionRequest
 */
export interface AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollectionRequest {
    /**
     * 
     * @type {PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest}
     * @memberof AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollection
     */
    readonly postPrixAnnonceLegaleAnnonceLegaleCollectionRequest: PostPrixAnnonceLegaleAnnonceLegaleCollectionRequest

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollection
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for putAnnonceLegaleAnnonceLegaleItem operation in AnnoncesLegalesApi.
 * @export
 * @interface AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItemRequest
 */
export interface AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItemRequest {
    /**
     * Identifiant de la prestation
     * @type {number}
     * @memberof AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItem
     */
    readonly id: number

    /**
     * 
     * @type {PostAnnonceLegaleAnnonceLegaleCollectionRequest}
     * @memberof AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItem
     */
    readonly postAnnonceLegaleAnnonceLegaleCollectionRequest: PostAnnonceLegaleAnnonceLegaleCollectionRequest

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItem
     */
    readonly xIdSociete?: number
}

/**
 * AnnoncesLegalesApi - object-oriented interface
 * @export
 * @class AnnoncesLegalesApi
 * @extends {BaseAPI}
 */
export class AnnoncesLegalesApi extends BaseAPI {
    /**
     * Récupérer les détails d\'un type d\'annonce légale
     * @summary Récupérer les détails d\'un type d\'annonce légale
     * @param {AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getAnnonceLegaleAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiGetAnnonceLegaleAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getAnnonceLegaleAnnonceLegaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer la liste des types d\'annonces légales
     * @summary Récupérer la liste des types d\'annonces légales
     * @param {AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getListAnnoncesLegalesAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetListAnnoncesLegalesAnnonceLegaleCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getListAnnoncesLegalesAnnonceLegaleCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.id, requestParameters.id2, requestParameters.origine, requestParameters.origine2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
     * @summary Récupérer le top nTopResults de la liste des sous-types d\'annonces légales
     * @param {AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection(requestParameters: AnnoncesLegalesApiGetPalmaresStypePalmaresSTypesAnnoncesLegalesCollectionRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getPalmaresStypePalmaresSTypesAnnoncesLegalesCollection(requestParameters.nTopResults, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retourne le nom du support et les prochaines dates de parution via la procédure Parution3Mois
     * @summary Dates de parution sur 3 mois pour une édition JAL
     * @param {AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getParutionsJalEditionAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetParutionsJalEditionAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getParutionsJalEditionAnnonceLegaleCollection(requestParameters.idjaledition, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retourne le mode de tarification applicable (au caractère, au forfait, DNID ou journal officiel) pour un sous-type d\'annonce, un département et une date donnés
     * @summary Récupérer les informations de tarification d\'un sous-type d\'annonce
     * @param {AnnoncesLegalesApiGetPricingAnnonceLegaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getPricingAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiGetPricingAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getPricingAnnonceLegaleItem(requestParameters.id, requestParameters.xIdSociete, requestParameters.departmentCode, requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupere les informations de tarification par sous type
     * @summary Récupere les informations de tarification par sous type
     * @param {AnnoncesLegalesApiGetPricingsAnnonceLegaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getPricingsAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetPricingsAnnonceLegaleCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getPricingsAnnonceLegaleCollection(requestParameters.xIdSociete, requestParameters.departmentCode, requestParameters.date, requestParameters.page, requestParameters.id, requestParameters.id2, requestParameters.origine, requestParameters.origine2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retourne les supports JAL disponibles pour un département et un sous-type d\'annonce, via la procédure ws_Dep_JAL
     * @summary Lister les supports JAL disponibles
     * @param {AnnoncesLegalesApiGetSupportAnnonceLegaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public getSupportAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiGetSupportAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).getSupportAnnonceLegaleCollection(requestParameters.dep, requestParameters.idSType, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Annule une annonce légale via le webservice SOAP WS Client Ext (SET_AnnuleAnnonce)
     * @summary Annuler une annonce légale
     * @param {AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public patchAnnuleAnnonceLegaleAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiPatchAnnuleAnnonceLegaleAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).patchAnnuleAnnonceLegaleAnnonceLegaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transmet la saisie d\'une nouvelle annonce légale
     * @summary Créer une annonce légale
     * @param {AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public postAnnonceLegaleAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiPostAnnonceLegaleAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).postAnnonceLegaleAnnonceLegaleCollection(requestParameters.postAnnonceLegaleAnnonceLegaleCollectionRequest, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calcule le tarif d\'une annonce légale sans la sauvegarder
     * @summary Calculer le prix d\'une annonce légale
     * @param {AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public postPrixAnnonceLegaleAnnonceLegaleCollection(requestParameters: AnnoncesLegalesApiPostPrixAnnonceLegaleAnnonceLegaleCollectionRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).postPrixAnnonceLegaleAnnonceLegaleCollection(requestParameters.postPrixAnnonceLegaleAnnonceLegaleCollectionRequest, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transmet la mise à jour d\'une annonce légale
     * @summary Mettre à jour une annonce légale
     * @param {AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnoncesLegalesApi
     */
    public putAnnonceLegaleAnnonceLegaleItem(requestParameters: AnnoncesLegalesApiPutAnnonceLegaleAnnonceLegaleItemRequest, options?: RawAxiosRequestConfig) {
        return AnnoncesLegalesApiFp(this.configuration).putAnnonceLegaleAnnonceLegaleItem(requestParameters.id, requestParameters.postAnnonceLegaleAnnonceLegaleCollectionRequest, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrestationAnnonceLgaleApi - axios parameter creator
 * @export
 */
export const PrestationAnnonceLgaleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer la liste des prestations d\'annonces légales
         * @summary Récupérer la liste des prestations d\'annonces légales
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [dossierStatut] 
         * @param {Array<number>} [dossierStatut2] 
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [typePrestaId] 
         * @param {Array<number>} [typePrestaId2] 
         * @param {number} [dossierNumero] 
         * @param {string} [q] 
         * @param {boolean} [formaliste] Filter prestations edited by formalistes
         * @param {boolean} [validationProcess] Filter prestations by active validation process
         * @param {boolean} [bodacc] Filter prestations that contains bodacc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListTblPrestaPrestationAnnonceLgaleCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, dossierStatut?: number, dossierStatut2?: Array<number>, id?: number, id2?: Array<number>, typePrestaId?: number, typePrestaId2?: Array<number>, dossierNumero?: number, q?: string, formaliste?: boolean, validationProcess?: boolean, bodacc?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/annonces-legales/prestations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (dossierStatut !== undefined) {
                localVarQueryParameter['dossier.statut'] = dossierStatut;
            }

            if (dossierStatut2) {
                localVarQueryParameter['dossier.statut[]'] = dossierStatut2;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (id2) {
                localVarQueryParameter['id[]'] = id2;
            }

            if (typePrestaId !== undefined) {
                localVarQueryParameter['typePresta.id'] = typePrestaId;
            }

            if (typePrestaId2) {
                localVarQueryParameter['typePresta.id[]'] = typePrestaId2;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (formaliste !== undefined) {
                localVarQueryParameter['formaliste'] = formaliste;
            }

            if (validationProcess !== undefined) {
                localVarQueryParameter['validation_process'] = validationProcess;
            }

            if (bodacc !== undefined) {
                localVarQueryParameter['bodacc'] = bodacc;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne la liste des prestations via la procédure stockée appro_ListePresta, filtrée par l\'identité du prescripteur connecté
         * @summary Lister les prestations du prescripteur
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {string} [refCdeClient] Référence utilisée par le prescripteur dans son système
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListePrestaPrestationAnnonceLgaleCollection: async (xIdSociete?: number, refCdeClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/annonces-legales/prestations/liste`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (refCdeClient !== undefined) {
                localVarQueryParameter['RefCdeClient'] = refCdeClient;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer l\'attestation d\'une prestation d\'annonce légale
         * @summary Récupérer l\'attestation d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaAttestationPrestationAnnonceLgaleItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTblPrestaAttestationPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}/attestation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retourne la liste des destinataires d\'exemplaires (TBL_LivraisonExemplaires) associés à la prestation
         * @summary Récupérer les destinataires de livraison d\'une prestation
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaDestinatairesPrestationAnnonceLgaleItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}/destinataires`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Génère et retourne le PDF du devis via le webservice GenPdf
         * @summary Télécharger le devis d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaDevisPrestationAnnonceLgaleItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTblPrestaDevisPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}/devis`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Appelle le webservice JAL (Get_Base64_2) pour récupérer le PDF justificatif d\'une prestation
         * @summary Récupérer le justificatif PDF depuis le JAL
         * @param {number} id Identifiant de la prestation
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaJustifJalPrestationAnnonceLgaleItem: async (id: number, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTblPrestaJustifJalPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}/justif-jal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une prestation d\'annonce légale
         * @summary Récupérer les informations d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaJustifPrestationAnnonceLgaleItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTblPrestaJustifPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}/justif`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une prestation d\'annonce légale
         * @summary Récupérer les informations d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaPrestationAnnonceLgaleItem: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTblPrestaPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mettre à jour uniquement le champ fCoupureDiffusion d\'une prestation d\'annonce légale
         * @summary Mettre à jour la coupure de diffusion d\'une prestation
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest} [patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem: async (id: string, xIdSociete?: number, patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest?: PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem', 'id', id)
            const localVarPath = `/annonces-legales/prestations/{id}/coupure-diffusion`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mise à jour partielle d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
         * @summary Modifier partiellement un destinataire de livraison
         * @param {string} id Resource identifier
         * @param {PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest} patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTblPrestaDestinatairesPrestationAnnonceLgaleItem: async (id: string, patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'id', id)
            // verify required parameter 'patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest' is not null or undefined
            assertParamExists('patchTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest', patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest)
            const localVarPath = `/annonces-legales/prestations/{id}/destinataires/{idLiv}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Crée une entrée dans TBL_LivraisonExemplaires et met à jour ExemplaireNB sur la prestation
         * @summary Ajouter un destinataire de livraison
         * @param {string} id Resource identifier
         * @param {PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest} postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTblPrestaDestinatairesPrestationAnnonceLgaleItem: async (id: string, postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('postTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'id', id)
            // verify required parameter 'postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest' is not null or undefined
            assertParamExists('postTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest', postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest)
            const localVarPath = `/annonces-legales/prestations/{id}/destinataires`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mise à jour complète d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
         * @summary Remplacer un destinataire de livraison
         * @param {string} id Resource identifier
         * @param {PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest} putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTblPrestaDestinatairesPrestationAnnonceLgaleItem: async (id: string, putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'id', id)
            // verify required parameter 'putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest' is not null or undefined
            assertParamExists('putTblPrestaDestinatairesPrestationAnnonceLgaleItem', 'putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest', putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest)
            const localVarPath = `/annonces-legales/prestations/{id}/destinataires/{idLiv}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrestationAnnonceLgaleApi - functional programming interface
 * @export
 */
export const PrestationAnnonceLgaleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrestationAnnonceLgaleApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer la liste des prestations d\'annonces légales
         * @summary Récupérer la liste des prestations d\'annonces légales
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [dossierStatut] 
         * @param {Array<number>} [dossierStatut2] 
         * @param {number} [id] 
         * @param {Array<number>} [id2] 
         * @param {number} [typePrestaId] 
         * @param {Array<number>} [typePrestaId2] 
         * @param {number} [dossierNumero] 
         * @param {string} [q] 
         * @param {boolean} [formaliste] Filter prestations edited by formalistes
         * @param {boolean} [validationProcess] Filter prestations by active validation process
         * @param {boolean} [bodacc] Filter prestations that contains bodacc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListTblPrestaPrestationAnnonceLgaleCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, dossierStatut?: number, dossierStatut2?: Array<number>, id?: number, id2?: Array<number>, typePrestaId?: number, typePrestaId2?: Array<number>, dossierNumero?: number, q?: string, formaliste?: boolean, validationProcess?: boolean, bodacc?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListTblPrestaPrestationAnnonceLGaleCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListTblPrestaPrestationAnnonceLgaleCollection(xIdSociete, page, itemsPerPage, dossierStatut, dossierStatut2, id, id2, typePrestaId, typePrestaId2, dossierNumero, q, formaliste, validationProcess, bodacc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getListTblPrestaPrestationAnnonceLgaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retourne la liste des prestations via la procédure stockée appro_ListePresta, filtrée par l\'identité du prescripteur connecté
         * @summary Lister les prestations du prescripteur
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {string} [refCdeClient] Référence utilisée par le prescripteur dans son système
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListePrestaPrestationAnnonceLgaleCollection(xIdSociete?: number, refCdeClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListePrestaPrestationAnnonceLgaleCollection(xIdSociete, refCdeClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getListePrestaPrestationAnnonceLgaleCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer l\'attestation d\'une prestation d\'annonce légale
         * @summary Récupérer l\'attestation d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTblPrestaAttestationPrestationAnnonceLgaleItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTblPrestaAttestationPrestationAnnonceLgaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getTblPrestaAttestationPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retourne la liste des destinataires d\'exemplaires (TBL_LivraisonExemplaires) associés à la prestation
         * @summary Récupérer les destinataires de livraison d\'une prestation
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTblPrestaDestinatairesPrestationAnnonceLgaleItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTblPrestaDestinatairesPrestationAnnonceLgaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getTblPrestaDestinatairesPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Génère et retourne le PDF du devis via le webservice GenPdf
         * @summary Télécharger le devis d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTblPrestaDevisPrestationAnnonceLgaleItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTblPrestaDevisPrestationAnnonceLgaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getTblPrestaDevisPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Appelle le webservice JAL (Get_Base64_2) pour récupérer le PDF justificatif d\'une prestation
         * @summary Récupérer le justificatif PDF depuis le JAL
         * @param {number} id Identifiant de la prestation
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTblPrestaJustifJalPrestationAnnonceLgaleItem(id: number, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTblPrestaJustifJalPrestationAnnonceLgaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getTblPrestaJustifJalPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une prestation d\'annonce légale
         * @summary Récupérer les informations d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTblPrestaJustifPrestationAnnonceLgaleItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTblPrestaJustifPrestationAnnonceLgaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getTblPrestaJustifPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une prestation d\'annonce légale
         * @summary Récupérer les informations d\'une prestation d\'annonce légale
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTblPrestaPrestationAnnonceLgaleItem(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationAnnonceLGaleJsonldPrestaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTblPrestaPrestationAnnonceLgaleItem(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.getTblPrestaPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mettre à jour uniquement le champ fCoupureDiffusion d\'une prestation d\'annonce légale
         * @summary Mettre à jour la coupure de diffusion d\'une prestation
         * @param {string} id Resource identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest} [patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem(id: string, xIdSociete?: number, patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest?: PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem(id, xIdSociete, patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mise à jour partielle d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
         * @summary Modifier partiellement un destinataire de livraison
         * @param {string} id Resource identifier
         * @param {PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest} patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTblPrestaDestinatairesPrestationAnnonceLgaleItem(id: string, patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTblPrestaDestinatairesPrestationAnnonceLgaleItem(id, patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.patchTblPrestaDestinatairesPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Crée une entrée dans TBL_LivraisonExemplaires et met à jour ExemplaireNB sur la prestation
         * @summary Ajouter un destinataire de livraison
         * @param {string} id Resource identifier
         * @param {PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest} postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTblPrestaDestinatairesPrestationAnnonceLgaleItem(id: string, postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTblPrestaDestinatairesPrestationAnnonceLgaleItem(id, postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.postTblPrestaDestinatairesPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mise à jour complète d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
         * @summary Remplacer un destinataire de livraison
         * @param {string} id Resource identifier
         * @param {PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest} putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest 
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTblPrestaDestinatairesPrestationAnnonceLgaleItem(id: string, putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTblPrestaDestinatairesPrestationAnnonceLgaleItem(id, putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrestationAnnonceLgaleApi.putTblPrestaDestinatairesPrestationAnnonceLgaleItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrestationAnnonceLgaleApi - factory interface
 * @export
 */
export const PrestationAnnonceLgaleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrestationAnnonceLgaleApiFp(configuration)
    return {
        /**
         * Récupérer la liste des prestations d\'annonces légales
         * @summary Récupérer la liste des prestations d\'annonces légales
         * @param {PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListTblPrestaPrestationAnnonceLgaleCollection(requestParameters: PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetListTblPrestaPrestationAnnonceLGaleCollection200Response> {
            return localVarFp.getListTblPrestaPrestationAnnonceLgaleCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierStatut, requestParameters.dossierStatut2, requestParameters.id, requestParameters.id2, requestParameters.typePrestaId, requestParameters.typePrestaId2, requestParameters.dossierNumero, requestParameters.q, requestParameters.formaliste, requestParameters.validationProcess, requestParameters.bodacc, options).then((request) => request(axios, basePath));
        },
        /**
         * Retourne la liste des prestations via la procédure stockée appro_ListePresta, filtrée par l\'identité du prescripteur connecté
         * @summary Lister les prestations du prescripteur
         * @param {PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListePrestaPrestationAnnonceLgaleCollection(requestParameters: PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetListePrestaPrestationAnnonceLGaleCollection200ResponseInner>> {
            return localVarFp.getListePrestaPrestationAnnonceLgaleCollection(requestParameters.xIdSociete, requestParameters.refCdeClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer l\'attestation d\'une prestation d\'annonce légale
         * @summary Récupérer l\'attestation d\'une prestation d\'annonce légale
         * @param {PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaAttestationPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTblPrestaAttestationPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retourne la liste des destinataires d\'exemplaires (TBL_LivraisonExemplaires) associés à la prestation
         * @summary Récupérer les destinataires de livraison d\'une prestation
         * @param {PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTblPrestaDestinatairesPrestationAnnonceLGaleItem200ResponseInner>> {
            return localVarFp.getTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Génère et retourne le PDF du devis via le webservice GenPdf
         * @summary Télécharger le devis d\'une prestation d\'annonce légale
         * @param {PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaDevisPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTblPrestaDevisPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Appelle le webservice JAL (Get_Base64_2) pour récupérer le PDF justificatif d\'une prestation
         * @summary Récupérer le justificatif PDF depuis le JAL
         * @param {PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaJustifJalPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTblPrestaJustifJalPrestationAnnonceLGaleItem200Response> {
            return localVarFp.getTblPrestaJustifJalPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une prestation d\'annonce légale
         * @summary Récupérer les informations d\'une prestation d\'annonce légale
         * @param {PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaJustifPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationAnnonceLGaleJsonldAnnonceLegaleReadJustif> {
            return localVarFp.getTblPrestaJustifPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une prestation d\'annonce légale
         * @summary Récupérer les informations d\'une prestation d\'annonce légale
         * @param {PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTblPrestaPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationAnnonceLGaleJsonldPrestaRead> {
            return localVarFp.getTblPrestaPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Mettre à jour uniquement le champ fCoupureDiffusion d\'une prestation d\'annonce légale
         * @summary Mettre à jour la coupure de diffusion d\'une prestation
         * @param {PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrestationAnnonceLGaleJsonldPrestaCoupureDiffusion> {
            return localVarFp.patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, requestParameters.patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mise à jour partielle d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
         * @summary Modifier partiellement un destinataire de livraison
         * @param {PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Crée une entrée dans TBL_LivraisonExemplaires et met à jour ExemplaireNB sur la prestation
         * @summary Ajouter un destinataire de livraison
         * @param {PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostTblPrestaDestinatairesPrestationAnnonceLGaleItem201Response> {
            return localVarFp.postTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Mise à jour complète d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
         * @summary Remplacer un destinataire de livraison
         * @param {PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getListTblPrestaPrestationAnnonceLgaleCollection operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest
 */
export interface PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly itemsPerPage?: number

    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly dossierStatut?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly dossierStatut2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly id?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly id2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly typePrestaId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly typePrestaId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly dossierNumero?: number

    /**
     * 
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly q?: string

    /**
     * Filter prestations edited by formalistes
     * @type {boolean}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly formaliste?: boolean

    /**
     * Filter prestations by active validation process
     * @type {boolean}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly validationProcess?: boolean

    /**
     * Filter prestations that contains bodacc
     * @type {boolean}
     * @memberof PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollection
     */
    readonly bodacc?: boolean
}

/**
 * Request parameters for getListePrestaPrestationAnnonceLgaleCollection operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollectionRequest
 */
export interface PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollection
     */
    readonly xIdSociete?: number

    /**
     * Référence utilisée par le prescripteur dans son système
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollection
     */
    readonly refCdeClient?: string
}

/**
 * Request parameters for getTblPrestaAttestationPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getTblPrestaDestinatairesPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getTblPrestaDevisPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getTblPrestaJustifJalPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItemRequest {
    /**
     * Identifiant de la prestation
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItem
     */
    readonly id: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getTblPrestaJustifPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getTblPrestaPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number

    /**
     * 
     * @type {PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest}
     * @memberof PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem
     */
    readonly patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest?: PatchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest
}

/**
 * Request parameters for patchTblPrestaDestinatairesPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * 
     * @type {PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest}
     * @memberof PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PatchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for postTblPrestaDestinatairesPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * 
     * @type {PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest}
     * @memberof PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PostTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for putTblPrestaDestinatairesPrestationAnnonceLgaleItem operation in PrestationAnnonceLgaleApi.
 * @export
 * @interface PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest
 */
export interface PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest {
    /**
     * Resource identifier
     * @type {string}
     * @memberof PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly id: string

    /**
     * 
     * @type {PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest}
     * @memberof PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest: PutTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItem
     */
    readonly xIdSociete?: number
}

/**
 * PrestationAnnonceLgaleApi - object-oriented interface
 * @export
 * @class PrestationAnnonceLgaleApi
 * @extends {BaseAPI}
 */
export class PrestationAnnonceLgaleApi extends BaseAPI {
    /**
     * Récupérer la liste des prestations d\'annonces légales
     * @summary Récupérer la liste des prestations d\'annonces légales
     * @param {PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getListTblPrestaPrestationAnnonceLgaleCollection(requestParameters: PrestationAnnonceLgaleApiGetListTblPrestaPrestationAnnonceLgaleCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getListTblPrestaPrestationAnnonceLgaleCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.dossierStatut, requestParameters.dossierStatut2, requestParameters.id, requestParameters.id2, requestParameters.typePrestaId, requestParameters.typePrestaId2, requestParameters.dossierNumero, requestParameters.q, requestParameters.formaliste, requestParameters.validationProcess, requestParameters.bodacc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retourne la liste des prestations via la procédure stockée appro_ListePresta, filtrée par l\'identité du prescripteur connecté
     * @summary Lister les prestations du prescripteur
     * @param {PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getListePrestaPrestationAnnonceLgaleCollection(requestParameters: PrestationAnnonceLgaleApiGetListePrestaPrestationAnnonceLgaleCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getListePrestaPrestationAnnonceLgaleCollection(requestParameters.xIdSociete, requestParameters.refCdeClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer l\'attestation d\'une prestation d\'annonce légale
     * @summary Récupérer l\'attestation d\'une prestation d\'annonce légale
     * @param {PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getTblPrestaAttestationPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaAttestationPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getTblPrestaAttestationPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retourne la liste des destinataires d\'exemplaires (TBL_LivraisonExemplaires) associés à la prestation
     * @summary Récupérer les destinataires de livraison d\'une prestation
     * @param {PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Génère et retourne le PDF du devis via le webservice GenPdf
     * @summary Télécharger le devis d\'une prestation d\'annonce légale
     * @param {PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getTblPrestaDevisPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaDevisPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getTblPrestaDevisPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Appelle le webservice JAL (Get_Base64_2) pour récupérer le PDF justificatif d\'une prestation
     * @summary Récupérer le justificatif PDF depuis le JAL
     * @param {PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getTblPrestaJustifJalPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaJustifJalPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getTblPrestaJustifJalPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une prestation d\'annonce légale
     * @summary Récupérer les informations d\'une prestation d\'annonce légale
     * @param {PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getTblPrestaJustifPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaJustifPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getTblPrestaJustifPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une prestation d\'annonce légale
     * @summary Récupérer les informations d\'une prestation d\'annonce légale
     * @param {PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public getTblPrestaPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiGetTblPrestaPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).getTblPrestaPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mettre à jour uniquement le champ fCoupureDiffusion d\'une prestation d\'annonce légale
     * @summary Mettre à jour la coupure de diffusion d\'une prestation
     * @param {PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPatchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).patchTblPrestaCoupureDiffusionPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.xIdSociete, requestParameters.patchTblPrestaCoupureDiffusionPrestationAnnonceLGaleItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mise à jour partielle d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
     * @summary Modifier partiellement un destinataire de livraison
     * @param {PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public patchTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPatchTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).patchTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.patchTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Crée une entrée dans TBL_LivraisonExemplaires et met à jour ExemplaireNB sur la prestation
     * @summary Ajouter un destinataire de livraison
     * @param {PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public postTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPostTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).postTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.postTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mise à jour complète d\'une entrée TBL_LivraisonExemplaires et synchronisation d\'ExemplaireNB
     * @summary Remplacer un destinataire de livraison
     * @param {PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrestationAnnonceLgaleApi
     */
    public putTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters: PrestationAnnonceLgaleApiPutTblPrestaDestinatairesPrestationAnnonceLgaleItemRequest, options?: RawAxiosRequestConfig) {
        return PrestationAnnonceLgaleApiFp(this.configuration).putTblPrestaDestinatairesPrestationAnnonceLgaleItem(requestParameters.id, requestParameters.putTblPrestaDestinatairesPrestationAnnonceLGaleItemRequest, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypesAnnoncesLegalesParOrigineApi - axios parameter creator
 * @export
 */
export const TypesAnnoncesLegalesParOrigineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
         * @summary Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
         * @param {number} iDOrigine L\&#39;ID de l\&#39;origine
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection: async (iDOrigine: number, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDOrigine' is not null or undefined
            assertParamExists('getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection', 'iDOrigine', iDOrigine)
            const localVarPath = `/annonces-legales/types/{IDOrigine}`
                .replace(`{${"IDOrigine"}}`, encodeURIComponent(String(iDOrigine)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypesAnnoncesLegalesParOrigineApi - functional programming interface
 * @export
 */
export const TypesAnnoncesLegalesParOrigineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypesAnnoncesLegalesParOrigineApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
         * @summary Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
         * @param {number} iDOrigine L\&#39;ID de l\&#39;origine
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection(iDOrigine: number, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection(iDOrigine, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypesAnnoncesLegalesParOrigineApi.getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypesAnnoncesLegalesParOrigineApi - factory interface
 * @export
 */
export const TypesAnnoncesLegalesParOrigineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypesAnnoncesLegalesParOrigineApiFp(configuration)
    return {
        /**
         * Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
         * @summary Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
         * @param {TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection(requestParameters: TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection200ResponseInner>> {
            return localVarFp.getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection(requestParameters.iDOrigine, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection operation in TypesAnnoncesLegalesParOrigineApi.
 * @export
 * @interface TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollectionRequest
 */
export interface TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollectionRequest {
    /**
     * L\&#39;ID de l\&#39;origine
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection
     */
    readonly iDOrigine: number

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollection
     */
    readonly xIdSociete?: number
}

/**
 * TypesAnnoncesLegalesParOrigineApi - object-oriented interface
 * @export
 * @class TypesAnnoncesLegalesParOrigineApi
 * @extends {BaseAPI}
 */
export class TypesAnnoncesLegalesParOrigineApi extends BaseAPI {
    /**
     * Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
     * @summary Récupérer la liste des types et des sous-types d\'annonces légales suivant un IDOrigine
     * @param {TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypesAnnoncesLegalesParOrigineApi
     */
    public getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection(requestParameters: TypesAnnoncesLegalesParOrigineApiGetTypesParOrigineTypesAnnoncesLegalesParOrigineCollectionRequest, options?: RawAxiosRequestConfig) {
        return TypesAnnoncesLegalesParOrigineApiFp(this.configuration).getTypesParOrigineTypesAnnoncesLegalesParOrigineCollection(requestParameters.iDOrigine, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



